import { IconJsxer } from "../IconHelper";
import { VISUALISATION_COMPONENTS_LIST } from "./VisualisationComponentsConfig";

import { WorkspaceConfig } from "../../components/v2/CustomisationWorkspace/DisruptorConfigFiles/WorkspaceConfig";

export const ENUM_LISTS = {
    visualisationComponents: VISUALISATION_COMPONENTS_LIST,
}

const generateUniqueId = () => {
    return Math.random().toString(36).substr(2, 16);
}

const getNameIcon = (node) => {
    if (node.customisationContainerType === 'group') {
        if (node.subNodes[0].subNodes[0].path.includes('is-enabled') && node.subNodes[0].subNodes[0].subNodes[0].booleanValue) {
            return IconJsxer.GetIcon(IconJsxer.ICONS.newFormatTool_visualGroup, IconJsxer.ICON_STYLES.standard);
        } else {
            return IconJsxer.GetIcon(IconJsxer.ICONS.newFormatTool_objectGroup, IconJsxer.ICON_STYLES.standard);
        }
    }
    if (node.customisationContainerType === 'module') {
        return IconJsxer.GetIcon(IconJsxer.ICONS.newFormatTool_module, IconJsxer.ICON_STYLES.standard);
    }
    if (node.customisationContainerType === 'field') {
        return IconJsxer.GetIcon(IconJsxer.ICONS.newFormatTool_field, IconJsxer.ICON_STYLES.standard);
    }
    return null;
}
export const RenderNodeName = (nodeName, node, nodes) => {
    if (node.isActiveCustomisation) {
        return (
            <div className="boolean-true-option">{nodeName}</div>
        );
    } else
    if (node.isAddButton) {
        return (
            <div className="add-node-button">{nodeName}</div>
        );
    } else
    if (node.subNodes && node.subNodes.length > 0 && node.subNodes[0].isBoolean) {
        if (node.subNodes[0].booleanValue) {
            return (
                <div className="boolean-true-option">{nodeName}</div>
            );
        } else {
            return (
                <div className="boolean-false-option">{nodeName}</div>
            );
        }
    } else
    if (node.isBoolean) {
        if (node.booleanValue) {
            return (
                <div className="boolean-true-option">{nodeName}</div>
            );
        } else {
            return (
                <div className="boolean-false-option">{nodeName}</div>
            );
        }
    } else
    if ((node.alwaysAtTop || node.parent?.alwaysAtTop) && node.enabled) {
        return (
            <div className="fixed-to-top-option">{nodeName}</div>
        );
    } else
    if (node.defaultToRightClickMenu) {
        return (
            <div className="default-to-right-click-option">{nodeName}</div>
        );
    } else
    if (node.subNodes && node.subNodes.length > 0 && node.subNodes[0].linkable && node.subNodes[0].link !== null) {
        return (
            <div className="linked-child-option">{nodeName}</div>
        )
    } else
    if (node.subNodes && node.subNodes.length > 0 && node.subNodes[0].linkable && node.subNodes[0].link === null) {
        return (
            <div className="unlinked-child-option">{nodeName}</div>
        )
    } else if (node.subNodes && node.subNodes.length > 0 && node.subNodes[0].valueLink && node.subNodes[0].name !== '<No Value>') {
        return (
            <div className="linked-child-value-option">{nodeName}</div>
        );
    } else if (node.subNodes && node.subNodes.length > 0 && node.subNodes[0].valueLink && node.subNodes[0].name === '<No Value>') {
        return (
            <div className="unlinked-child-option">{nodeName}</div>
        );
    }
    return <>{getNameIcon(node)} {nodeName} </>;
}

export const exportFeatureConfigJsonFileDataFromNodeListData = (featureNode, configDataNode) => {
    const newFormatData = processNodesToFinalDataObject(featureNode, configDataNode);
    const jsonData = JSON.stringify(newFormatData, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const link = document.createElement('a');
    link.download = `${newFormatData.featureName.split(' ').join('')}-${newFormatData.featureKey}-config.json`;
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
    return newFormatData;
}

export const importFeatureConfigJsonFileDataToNodeListData = (node, completedCallback) => {
    console.log("Importing feature config JSON file data to node list data for node: ", node);
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.json';
    fileInput.onchange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const jsonData = JSON.parse(event.target.result);
                const nodes = processExportedConfigDataObjectToNodes(node.id, node.instanceId, node.name, node.featureKey, jsonData);
                if (completedCallback) {
                    completedCallback(nodes);
                }
            } catch (error) {
                console.error("Error parsing JSON file: ", error);
                alert("There was an error parsing the JSON file. Please make sure it is a valid config file exported from the timeline builder.");
            }
        };
        reader.readAsText(file);
    };
    fileInput.click();
}

/*
    * This function is supposed to take the final data object format and process it back to the node format used by the timeline builder.
    * This allows us to load in existing config json files into the timeline builder for editing.
    * 
*/
export const processExportedConfigDataObjectToNodes = (featureId, instanceId, instanceName, featureKey, dataObject) => {
    console.log("Processing exported config data object to nodes. Data object: ", dataObject, featureId, instanceId, instanceName);
    const nodes = getInitialNewFormatData(featureId, dataObject.featureName, instanceId, instanceName);
    nodes.featureKey = featureKey; // We need to set the feature key on the node so we can use it for data linking
    processExportedConfigDataObjectTimelineToNodes(dataObject, nodes);

    for (let i = 0; i < dataObject.customisation?.groups?.length; i++) {
        const customisationGroupData = dataObject.customisation.groups[i];
        const groupNode = processCustomisationGroupDataObjectToNodes(customisationGroupData, featureKey, true);
        nodes.subNodes[1].subNodes.push(groupNode);
    }

    console.log("Finished processing exported config data object to nodes. Resulting nodes: ", nodes);
    return nodes;
}

const processCustomisationGroupDataObjectToNodes = (customisationGroupData, featureKey, topLevel = false) => {
    const groupNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.customisationGroup));
    const uid = generateUniqueId();
    groupNode.id = `${featureKey}-customisation-group-${customisationGroupData.name.toLowerCase().replace(/\s+/g, '-')}-${uid}`;
    groupNode.name = customisationGroupData.name;
    groupNode.path = `${featureKey}.customisation.groups.${customisationGroupData.name.toLowerCase().replace(/\s+/g, '-')}-${uid}`;
    console.log("Processing customisation group data object to nodes. customisationGroupData: ", customisationGroupData);
    console.log("Initial group node created from blank structure: ", groupNode);

    // We are going to remove any nodes in our customisation-group-visualisation-settings that are set to removeFromNestedGroups if we are not a topLevel group
    if (topLevel === false) {
        const visualisationConfigNodeIndex = groupNode.subNodes.findIndex(node => node.id === 'customisation-group-visualisation-settings');
        if (visualisationConfigNodeIndex !== -1) {
            const visualisationConfigNode = groupNode.subNodes[visualisationConfigNodeIndex];
            visualisationConfigNode.subNodes = visualisationConfigNode.subNodes.filter(node => !node.removeFromNestedGroups);
        }
    }

    // Set up the groupConfig subNode based on the customisation group data
    const groupConfig = JSON.parse(JSON.stringify(BLANK_STRUCTURES.groupConfig));
    const flatGroupSettings = customisationGroupData.groupSettings;

    const includeInVisualisationSubNode = groupConfig.subNodes.find(node => node.id === 'include-in-visualisation');
    if (includeInVisualisationSubNode) {
        includeInVisualisationSubNode.subNodes[0].booleanValue = flatGroupSettings?.visualise ?? true;
        includeInVisualisationSubNode.subNodes[0].name = (flatGroupSettings?.visualise ?? true) ? 'True' : 'False';
    }

    const groupLinkageSubNode = groupConfig.subNodes.find(node => node.id === 'group-linkage');
    if (groupLinkageSubNode) {
        groupLinkageSubNode.subNodes[0].link = flatGroupSettings?.dataLink ?? null;
        groupLinkageSubNode.subNodes[0].name = flatGroupSettings?.dataLink ? `<${flatGroupSettings.dataLink}>` : '<Not Linked>';
        if (flatGroupSettings?.csvUploader) {
            const csvUploaderSubNode = groupLinkageSubNode.subNodes.find(node => node.id === 'csv-uploader');
            if (csvUploaderSubNode) {
                // Process CSV uploader settings here
                const enabledSubNode = csvUploaderSubNode.subNodes.find(node => node.id === 'enable-csv-uploader-value');
                if (enabledSubNode) {
                    enabledSubNode.booleanValue = flatGroupSettings.csvUploader.enabled;
                    enabledSubNode.name = flatGroupSettings.csvUploader.enabled ? 'True' : 'False';
                }
                const titleSubNode = csvUploaderSubNode.subNodes.find(node => node.id === 'csv-uploader-title');
                if (titleSubNode) {
                    titleSubNode.name = flatGroupSettings.csvUploader.title ?? 'CSV Uploader';
                }
                const descriptionSubNode = csvUploaderSubNode.subNodes.find(node => node.id === 'csv-uploader-description');
                if (descriptionSubNode) {
                    descriptionSubNode.name = flatGroupSettings.csvUploader.description ?? '';
                }
                const fieldsSubNode = csvUploaderSubNode.subNodes.find(node => node.id === 'csv-uploader-fields');
                if (fieldsSubNode) {
                    // Process CSV uploader fields here
                    const flatFieldsArray = flatGroupSettings.csvUploader.fields || [];
                    for (let i = 0; i < flatFieldsArray.length; i++) {
                        const fieldData = flatFieldsArray[i];
                        const newFieldDataNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.csvUploaderField));
                        newFieldDataNode.name = fieldData.name;
                        newFieldDataNode.subNodes[1].link = fieldData.dataLink ?? null;
                        newFieldDataNode.subNodes[1].name = fieldData.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                        fieldsSubNode.subNodes.push(newFieldDataNode);
                    }
                }
            }
        }
    }

    const useDynamicNamingSubNode = groupConfig.subNodes.find(node => node.id === 'use-dynamic-naming');
    if (useDynamicNamingSubNode) {
        useDynamicNamingSubNode.subNodes[0].booleanValue = flatGroupSettings?.useDynamicNaming ?? false;
        useDynamicNamingSubNode.subNodes[0].name = (flatGroupSettings?.useDynamicNaming ?? false) ? 'True' : 'False';
    }
    const adjustPosWhileDraggingSubNode = groupConfig.subNodes.find(node => node.id === 'adjust-pos-while-dragging');
    if (adjustPosWhileDraggingSubNode) {
        adjustPosWhileDraggingSubNode.subNodes[0].booleanValue = flatGroupSettings?.adjustPosWhileDragging ?? false;
        adjustPosWhileDraggingSubNode.subNodes[0].name = (flatGroupSettings?.adjustPosWhileDragging ?? false) ? 'True' : 'False';
    }
    const preserveSpaceWhileDraggingSubNode = groupConfig.subNodes.find(node => node.id === 'preserve-space-while-dragging');
    if (preserveSpaceWhileDraggingSubNode) {
        preserveSpaceWhileDraggingSubNode.subNodes[0].booleanValue = flatGroupSettings?.preserveSpaceWhileDragging ?? false;
        preserveSpaceWhileDraggingSubNode.subNodes[0].name = (flatGroupSettings?.preserveSpaceWhileDragging ?? false) ? 'True' : 'False';
    }

    console.log("Processed groupConfig for customisation group. groupConfig node: ", groupConfig);
    groupNode.subNodes.push(groupConfig);

    // Set up the visualisationConfig subNode based on the customisation group data
    const visualisationConfigNode = groupNode.subNodes.find(node => node.id === 'customisation-group-visualisation-settings');

    const visualisationIsEnabledSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'is-visualisation-is-enabled');
    if (visualisationIsEnabledSubNode) {
        visualisationIsEnabledSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.isEnabled ?? false;
        visualisationIsEnabledSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.isEnabled ?? false) ? 'True' : 'False';
    }
    const visualisationToggleSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'visualisation-toggle');
    if (visualisationToggleSubNode) {
        visualisationToggleSubNode.subNodes[0].link = customisationGroupData.visualisationConfig?.toggle ?? null;
        visualisationToggleSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.toggle ? `<${customisationGroupData.visualisationConfig.toggle}>` : '<Not Linked>';
    }
    const reverseVisualisationToggleSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'reverse-visualisation-toggle');
    if (reverseVisualisationToggleSubNode) {
        reverseVisualisationToggleSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.reverseVisualisationToggle ?? false;
        reverseVisualisationToggleSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.reverseVisualisationToggle ?? false) ? 'True' : 'False';
    }
    const advancedVisualisationSettingsSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'advanced-visualisation-toggle');
    if (advancedVisualisationSettingsSubNode) {
        advancedVisualisationSettingsSubNode.subNodes[0].link = customisationGroupData.visualisationConfig?.advancedVisualisationToggleLink;
        advancedVisualisationSettingsSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.advancedVisualisationToggleLink ? `<${customisationGroupData.visualisationConfig.advancedVisualisationToggleLink}>` : '<Not Linked>';
        advancedVisualisationSettingsSubNode.subNodes[1].name = customisationGroupData.visualisationConfig?.advancedVisualisationToggleValue ?? '<No Value>';
        advancedVisualisationSettingsSubNode.subNodes[2].booleanValue = customisationGroupData.visualisationConfig?.advancedVisualisationToggleReverse ?? false;
        advancedVisualisationSettingsSubNode.subNodes[2].name = (customisationGroupData.visualisationConfig?.advancedVisualisationToggleReverse ?? false) ? 'True' : 'False';
    }
    const visualisationDirectionSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'visualisation-direction');
    if (visualisationDirectionSubNode) {
        visualisationDirectionSubNode.subNodes[0].enumValue = customisationGroupData.visualisationConfig?.direction;
        visualisationDirectionSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.direction ?? 'Left to Right';
    }
    const visualisationFlexSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'visualisation-flex');
    if (visualisationFlexSubNode) {
        visualisationFlexSubNode.subNodes[0].enumValue = customisationGroupData.visualisationConfig?.flex ?? 'Auto';
        visualisationFlexSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.flex ?? 'Auto';
    }
    const visualisationRestrictStepsSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'restrict-steps');
    if (visualisationRestrictStepsSubNode) {
        visualisationRestrictStepsSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.restrictSteps ?? false;
        visualisationRestrictStepsSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.restrictSteps ?? false) ? 'True' : 'False';
    }
    const visualisationPreserveDomSpaceSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'preserve-dom-space');
    if (visualisationPreserveDomSpaceSubNode) {
        visualisationPreserveDomSpaceSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.preserveDomSpace ?? false;
        visualisationPreserveDomSpaceSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.preserveDomSpace ?? false) ? 'True' : 'False';
    }
    const visualisationStartStepSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'start-step');
    if (visualisationStartStepSubNode) {
        visualisationStartStepSubNode.subNodes[0].dynamicLinkedIndex = customisationGroupData.visualisationConfig?.startStep ?? 0;
        // visualisationStartStepSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.startStep ?? '0';
    }
    const visualisationEndStepSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'end-step');
    if (visualisationEndStepSubNode) {
        visualisationEndStepSubNode.subNodes[0].dynamicLinkedIndex = customisationGroupData.visualisationConfig?.endStep ?? 0;
        // visualisationEndStepSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.endStep ?? '0';
    }
    const visualisationCustomVisualisationComponentSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'custom-visualisation-component');
    if (visualisationCustomVisualisationComponentSubNode) {
        visualisationCustomVisualisationComponentSubNode.subNodes[0].enumValue = customisationGroupData.visualisationConfig?.visualisationComponent ?? '<Standard>';
        visualisationCustomVisualisationComponentSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.visualisationComponent ?? '<Standard>';
    }
    const visualisationCustomComponentApplyStylesSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'custom-component-apply-styles');
    if (visualisationCustomComponentApplyStylesSubNode) {
        visualisationCustomComponentApplyStylesSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.applyVisualisationComponentStyles ?? false;
        visualisationCustomComponentApplyStylesSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.applyVisualisationComponentStyles ?? false) ? 'True' : 'False';
    }
    const visualisationOverflowSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'visualisation-overflow');
    if (visualisationOverflowSubNode) {
        visualisationOverflowSubNode.subNodes[0].enumValue = customisationGroupData.visualisationConfig?.overflow ?? 'hidden';
        visualisationOverflowSubNode.subNodes[0].name = customisationGroupData.visualisationConfig?.overflow ?? 'hidden';
    }
    const visualisationIsFullScreenSubNode = visualisationConfigNode.subNodes.find(node => node.id === 'visualisation-is-full-screen');
    if (visualisationIsFullScreenSubNode) {
        visualisationIsFullScreenSubNode.subNodes[0].booleanValue = customisationGroupData.visualisationConfig?.isFullScreen ?? false;
        visualisationIsFullScreenSubNode.subNodes[0].name = (customisationGroupData.visualisationConfig?.isFullScreen ?? false) ? 'True' : 'False';
    }

    console.log("Processed visualisationConfig for customisation group. visualisationConfig node: ", visualisationConfigNode);

    // Process any child groups or modules...
    for (let i = 0; i < customisationGroupData.children.length; i++) {
        const childData = customisationGroupData.children[i];
        if (childData.type === 'group') {
            const childGroupNode = processCustomisationGroupDataObjectToNodes(childData, featureKey);
            groupNode.subNodes.push(childGroupNode);
        } else if (childData.type === 'module') {
            // Process module data to create a module node, then push it to the groupNode.subNodes
            const moduleNode = processExportedModuleDataObjectToNodes(childData);
            groupNode.subNodes.push(moduleNode);
        }
    }

    return groupNode;
}

const processExportedModuleDataObjectToNodes = (moduleData) => {
    // Pull out the correct blank structure based on the module type
    const moduleNode = JSON.parse(JSON.stringify(CUSTOMISATION_MODULES[moduleData.module]));

    // Every module has a moduleConfig subNode, so we can start by populating that
    const moduleConfigNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.moduleConfig));

    // Populate our moduleConfig settings
    const includeInVisualisationSubNode = moduleConfigNode.subNodes.find(node => node.id === 'include-in-visualisation');
    if (includeInVisualisationSubNode) {
        includeInVisualisationSubNode.subNodes[0].booleanValue = moduleData.moduleSettings?.visualise ?? true;
        includeInVisualisationSubNode.subNodes[0].name = (moduleData.moduleSettings?.visualise ?? true) ? 'True' : 'False';
    }
    const applyToContentSubNode = moduleConfigNode.subNodes.find(node => node.id === 'apply-to-content');
    if (applyToContentSubNode) {
        applyToContentSubNode.subNodes[0].booleanValue = moduleData.moduleSettings?.applyToContent ?? false;
        applyToContentSubNode.subNodes[0].name = (moduleData.moduleSettings?.applyToContent ?? false) ? 'True' : 'False';
    }
    const visualisationToggleSubNode = moduleConfigNode.subNodes.find(node => node.id === 'visualisation-toggle');
    if (visualisationToggleSubNode) {
        visualisationToggleSubNode.subNodes[0].link = moduleData.moduleSettings?.visualisationToggle ?? null;
        visualisationToggleSubNode.subNodes[0].name = moduleData.moduleSettings?.visualisationToggle ? `<${moduleData.moduleSettings.visualisationToggle}>` : '<Not Linked>';
    }
    const reverseVisualisationToggleSubNode = moduleConfigNode.subNodes.find(node => node.id === 'reverse-visualisation-toggle');
    if (reverseVisualisationToggleSubNode) {
        reverseVisualisationToggleSubNode.subNodes[0].booleanValue = moduleData.moduleSettings?.reverseVisualisationToggle ?? false;
        reverseVisualisationToggleSubNode.subNodes[0].name = (moduleData.moduleSettings?.reverseVisualisationToggle ?? false) ? 'True' : 'False';
    }
    const advancedVisualisationToggleSubNode = moduleConfigNode.subNodes.find(node => node.id === 'advanced-visualisation-toggle');
    if (advancedVisualisationToggleSubNode) {
        advancedVisualisationToggleSubNode.subNodes[0].link = moduleData.moduleSettings?.advancedVisualisationToggleLink ?? null;
        advancedVisualisationToggleSubNode.subNodes[0].name = moduleData.moduleSettings?.advancedVisualisationToggleLink ? `<${moduleData.moduleSettings.advancedVisualisationToggleLink}>` : '<Not Linked>';
        advancedVisualisationToggleSubNode.subNodes[1].name = moduleData.moduleSettings?.advancedVisualisationToggleValue ?? '<No Value>';
        advancedVisualisationToggleSubNode.subNodes[2].booleanValue = moduleData.moduleSettings?.advancedVisualisationToggleReverse ?? false;
        advancedVisualisationToggleSubNode.subNodes[2].name = (moduleData.moduleSettings?.advancedVisualisationToggleReverse ?? false) ? 'True' : 'False';
    }
    const includeInModuleListSubNode = moduleConfigNode.subNodes.find(node => node.id === 'include-in-module-list');
    if (includeInModuleListSubNode) {
        includeInModuleListSubNode.subNodes[0].booleanValue = moduleData.moduleSettings?.showInModuleList ?? false;
        includeInModuleListSubNode.subNodes[0].name = (moduleData.moduleSettings?.showInModuleList ?? false) ? 'True' : 'False';
    }
    const hideUnneededFieldsSubNode = moduleConfigNode.subNodes.find(node => node.id === 'hide-unneeded-fields');
    if (hideUnneededFieldsSubNode) {
        hideUnneededFieldsSubNode.subNodes[0].booleanValue = moduleData.moduleSettings?.hideUnneededFields ?? false;
        hideUnneededFieldsSubNode.subNodes[0].name = (moduleData.moduleSettings?.hideUnneededFields ?? false) ? 'True' : 'False';
    }
    // Push the populated moduleConfigNode into our moduleNode
    moduleNode.subNodes.push(moduleConfigNode);
    moduleNode.name = moduleData.name;

    // Now we need to precess the actual module setup
    let fieldData = null;
    let foundNonCustomField = false;
    const firstCustomFieldBlock = [];
    switch (moduleData.module) {
        case 'custom':
            // Custom module is really simple, we just loop over the fields and populate the subNodes based on the field data
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                moduleNode.subNodes.push(newFieldNodeData);
            }
            break;

        case 'multiplesLinkage':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (!fieldData.field && fieldData.dataLink) {
                    foundNonCustomField = true;
                    const linkageSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-multiples-linkage-data-link');
                    if (linkageSubNode) {
                        linkageSubNode.link = fieldData.dataLink;
                        linkageSubNode.name = fieldData.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        case 'position':
            // Position module is complex!
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        // moduleNode.subNodes.unshift(newFieldNodeData);
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-position-position') {
                    foundNonCustomField = true;
                    const pm_positionSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-position-position');
                    if (pm_positionSubNode) {
                        pm_positionSubNode.name = fieldData.name;
                        pm_positionSubNode.subNodes[0].link = fieldData?.dataLink ?? null;

                        const posStrings = ['top-left', 'top-center', 'top-right', 'center-left', 'center', 'center-right', 'bottom-left', 'bottom-center', 'bottom-right'];
                        for (let i = 0; i < posStrings.length; i++) {
                            const posString = posStrings[i];
                            const posOptionSubNode = pm_positionSubNode.subNodes.find(node => node.id === `customisation-module-position-position-${posString}`);
                            if (posOptionSubNode) {
                                posOptionSubNode.subNodes[0].name = fieldData?.[`${posString}-value`] ?? '<No Value>';
                            }
                        }
                    }
                } else if (fieldData.field === 'customisation-module-position-offset') {
                    foundNonCustomField = true;
                    const offsetSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-position-offset');
                    if (offsetSubNode) {
                        offsetSubNode.name = fieldData?.name ?? 'Offset';
                        offsetSubNode.subNodes[0].name = fieldData?.['offset-x']?.name ?? 'X';
                        offsetSubNode.subNodes[0].subNodes[0].link = fieldData?.['offset-x']?.dataLink ?? null;
                        offsetSubNode.subNodes[0].subNodes[0].name = fieldData?.['offset-x']?.dataLink ? `<${fieldData['offset-x'].dataLink}>` : '<Not Linked>';
                        offsetSubNode.subNodes[1].name = fieldData?.['offset-y']?.name ?? 'Y';
                        offsetSubNode.subNodes[1].subNodes[0].link = fieldData?.['offset-y']?.dataLink ?? null;
                        offsetSubNode.subNodes[1].subNodes[0].name = fieldData?.['offset-y']?.dataLink ? `<${fieldData['offset-y'].dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-position-alignment') {
                    foundNonCustomField = true;
                    const alignmentSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-position-alignment');
                    if (alignmentSubNode) {
                        alignmentSubNode.name = fieldData?.name ?? 'Alignment';
                        const alignmentXSubNode = alignmentSubNode.subNodes.find(node => node.id === 'alignment-x');
                        if (alignmentXSubNode) {
                            alignmentXSubNode.name = fieldData?.["alignment-x"]?.name ?? 'Horizontal';
                            alignmentXSubNode.subNodes[0].link = fieldData?.["alignment-x"]?.dataLink ?? null;
                            alignmentXSubNode.subNodes[0].name = fieldData?.["alignment-x"]?.dataLink ? `<${fieldData["alignment-x"].dataLink}>` : '<Not Linked>';
                            const alignmentKeyParts = ['left', 'center', 'right'];
                            for (let i = 0; i < alignmentKeyParts.length; i++) {
                                const keyPart = alignmentKeyParts[i];
                                const optionSubNode = alignmentXSubNode.subNodes.find(node => node.id === `alignment-${keyPart}`);
                                if (optionSubNode) {
                                    optionSubNode.subNodes[0].name = fieldData?.[`alignment-${keyPart}-value`] ?? '<No Value>';
                                }
                            }
                        }
                        const alignmentYSubNode = alignmentSubNode.subNodes.find(node => node.id === 'alignment-y');
                        if (alignmentYSubNode) {
                            alignmentYSubNode.name = fieldData?.["alignment-y"]?.name ?? 'Vertical';
                            alignmentYSubNode.subNodes[0].link = fieldData?.["alignment-y"]?.dataLink ?? null;
                            alignmentYSubNode.subNodes[0].name = fieldData?.["alignment-y"]?.dataLink ? `<${fieldData["alignment-y"].dataLink}>` : '<Not Linked>';
                            const alignmentKeyParts = ['top', 'middle', 'bottom'];
                            for (let i = 0; i < alignmentKeyParts.length; i++) {
                                const keyPart = alignmentKeyParts[i];
                                const optionSubNode = alignmentYSubNode.subNodes.find(node => node.id === `alignment-${keyPart}`);
                                if (optionSubNode) {
                                    optionSubNode.subNodes[0].name = fieldData?.[`alignment-${keyPart}-value`] ?? '<No Value>';
                                }
                            }
                        }
                    }
                }
            }
            break;

        case 'dimensions':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-dimensions-dimensions') {
                    foundNonCustomField = true;
                    const dimensionsSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-dimensions-dimensions');
                    if (dimensionsSubNode) {
                        dimensionsSubNode.name = fieldData.name;
                        dimensionsSubNode.subNodes[0].name = fieldData?.['dimensions-width']?.name ?? 'W';
                        dimensionsSubNode.subNodes[0].subNodes[0].link = fieldData?.['dimensions-width']?.dataLink ?? null;
                        dimensionsSubNode.subNodes[0].subNodes[0].name = fieldData?.['dimensions-width']?.dataLink ? `<${fieldData['dimensions-width'].dataLink}>` : '<Not Linked>';
                        dimensionsSubNode.subNodes[1].name = fieldData?.['dimensions-height']?.name ?? 'H';
                        dimensionsSubNode.subNodes[1].subNodes[0].link = fieldData?.['dimensions-height']?.dataLink ?? null;
                        dimensionsSubNode.subNodes[1].subNodes[0].name = fieldData?.['dimensions-height']?.dataLink ? `<${fieldData['dimensions-height'].dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;
        
        case 'appearance':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-appearance-opacity') {
                    foundNonCustomField = true;
                    const opacitySubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-appearance-opacity');
                    if (opacitySubNode) {
                        opacitySubNode.name = fieldData?.name ?? 'Opacity';
                        opacitySubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        opacitySubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-appearance-corner-radius') {
                    foundNonCustomField = true;
                    const cornerRadiusSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-appearance-corner-radius');
                    if (cornerRadiusSubNode) {
                        cornerRadiusSubNode.name = fieldData?.name ?? 'Corner Radius';
                        cornerRadiusSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        cornerRadiusSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        case 'typography':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-typography-font') {
                    foundNonCustomField = true;
                    const fontSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-typography-font');
                    if (fontSubNode) {
                        fontSubNode.name = fieldData?.name ?? 'Font';
                        const fontFaceSubNode = fontSubNode.subNodes.find(node => node.id === 'customisation-module-typography-font-face');
                        if (fontFaceSubNode) {
                            fontFaceSubNode.subNodes[0].name = fieldData?.['customisation-module-typography-font-face']?.dataLink ? `<${fieldData['customisation-module-typography-font-face'].dataLink}>` : '<Not Linked>';
                            fontFaceSubNode.subNodes[0].link = fieldData?.['customisation-module-typography-font-face']?.dataLink ?? null;
                        }
                        const fontWeightSubNode = fontSubNode.subNodes.find(node => node.id === 'customisation-module-typography-font-weight');
                        if (fontWeightSubNode) {
                            const fontWeightKeys = ['narrow', 'normal', 'bold'];
                            for (let i = 0; i < fontWeightKeys.length; i++) {
                                const key = fontWeightKeys[i];
                                const optionSubNode = fontWeightSubNode.subNodes.find(node => node.id === `customisation-module-typography-font-weight-${key}`);
                                if (optionSubNode) {
                                    optionSubNode.subNodes[0].name = fieldData?.['customisation-module-typography-font-weight']?.[`customisation-module-typography-font-weight-${key}`]?.dataLink ? `<${fieldData['customisation-module-typography-font-weight']?.[`customisation-module-typography-font-weight-${key}`]?.dataLink}>` : '<Not Linked>';
                                    optionSubNode.subNodes[0].link = fieldData?.['customisation-module-typography-font-weight']?.[`customisation-module-typography-font-weight-${key}`]?.dataLink ?? null;
                                    optionSubNode.subNodes[1].name = fieldData?.['customisation-module-typography-font-weight']?.[`customisation-module-typography-font-weight-${key}`]?.value ?? '<No Value>';
                                    if (optionSubNode?.subNodes?.[2]?.subNodes?.[0] &&fieldData?.['customisation-module-typography-font-weight']?.[`customisation-module-typography-font-weight-${key}`]?.isDefault) {
                                        optionSubNode.subNodes[2].subNodes[0].booleanValue = true;
                                        optionSubNode.subNodes[2].subNodes[0].name = 'True';
                                    }
                                }
                            }
                        }
                    }
                } else if (fieldData.field === 'customisation-module-typography-size') {
                    foundNonCustomField = true;
                    const sizeSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-typography-size');
                    if (sizeSubNode) {
                        sizeSubNode.name = fieldData?.name ?? 'Size';
                        sizeSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        sizeSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-typography-line-height') {
                    foundNonCustomField = true;
                    const lineHeightSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-typography-line-height');
                    if (lineHeightSubNode) {
                        lineHeightSubNode.name = fieldData?.name ?? 'Line Height';
                        lineHeightSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        lineHeightSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-typography-text-color') {
                    foundNonCustomField = true;
                    const textColorSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-typography-text-color');
                    if (textColorSubNode) {
                        textColorSubNode.name = fieldData?.name ?? 'Text Color';
                        textColorSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        textColorSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-typography-text-alignment') {
                    foundNonCustomField = true;
                    const textAlignmentSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-typography-text-alignment');
                    if (textAlignmentSubNode) {
                        textAlignmentSubNode.name = fieldData?.name ?? 'Text Alignment';
                        const horizontalAlignmentSubNode = textAlignmentSubNode.subNodes.find(node => node.id === 'customisation-module-typography-text-alignment.horizontal');
                        if (horizontalAlignmentSubNode) {
                            horizontalAlignmentSubNode.name = fieldData?.['customisation-module-typography-text-alignment.horizontal']?.name ?? 'Horizontal';
                            const alignmentKeyParts = ['left', 'center', 'right'];
                            for (let i = 0; i < alignmentKeyParts.length; i++) {
                                const keyPart = alignmentKeyParts[i];
                                const optionSubNode = horizontalAlignmentSubNode.subNodes.find(node => node.id === `customisation-module-typography-text-alignment-horizontal.${keyPart}`);
                                if (optionSubNode) {
                                    optionSubNode.subNodes[0].name = fieldData?.['customisation-module-typography-text-alignment.horizontal']?.[`customisation-module-typography-text-alignment-horizontal.${keyPart}`]?.dataLink ? `<${fieldData['customisation-module-typography-text-alignment.horizontal']?.[`customisation-module-typography-text-alignment-horizontal.${keyPart}`]?.dataLink}>` : '<Not Linked>';
                                    optionSubNode.subNodes[0].link = fieldData?.['customisation-module-typography-text-alignment.horizontal']?.[`customisation-module-typography-text-alignment-horizontal.${keyPart}`]?.dataLink ?? null;
                                    optionSubNode.subNodes[1].name = fieldData?.['customisation-module-typography-text-alignment.horizontal']?.[`customisation-module-typography-text-alignment-horizontal.${keyPart}`]?.value ?? '<No Value>';
                                    if (optionSubNode?.subNodes?.[2]?.subNodes?.[0] && fieldData?.['customisation-module-typography-text-alignment.horizontal']?.[`customisation-module-typography-text-alignment-horizontal.${keyPart}`]?.isDefault) {
                                        optionSubNode.subNodes[2].subNodes[0].booleanValue = true;
                                        optionSubNode.subNodes[2].subNodes[0].name = 'True';
                                    }
                                }
                            }
                        }
                        const verticalAlignmentSubNode = textAlignmentSubNode.subNodes.find(node => node.id === 'customisation-module-typography-text-alignment.vertical');
                        if (verticalAlignmentSubNode) {
                            verticalAlignmentSubNode.name = fieldData?.['customisation-module-typography-text-alignment.vertical']?.name ?? 'Vertical';
                            const alignmentKeyParts = ['top', 'middle', 'bottom'];
                            for (let i = 0; i < alignmentKeyParts.length; i++) {
                                const keyPart = alignmentKeyParts[i];
                                const optionSubNode = verticalAlignmentSubNode.subNodes.find(node => node.id === `customisation-module-typography-text-alignment-vertical.${keyPart}`);
                                if (optionSubNode) {
                                    optionSubNode.subNodes[0].name = fieldData?.['customisation-module-typography-text-alignment.vertical']?.[`customisation-module-typography-text-alignment-vertical.${keyPart}`]?.dataLink ? `<${fieldData['customisation-module-typography-text-alignment.vertical']?.[`customisation-module-typography-text-alignment-vertical.${keyPart}`]?.dataLink}>` : '<Not Linked>';
                                    optionSubNode.subNodes[0].link = fieldData?.['customisation-module-typography-text-alignment.vertical']?.[`customisation-module-typography-text-alignment-vertical.${keyPart}`]?.dataLink ?? null;
                                    optionSubNode.subNodes[1].name = fieldData?.['customisation-module-typography-text-alignment.vertical']?.[`customisation-module-typography-text-alignment-vertical.${keyPart}`]?.value ?? '<No Value>';
                                    if (optionSubNode?.subNodes?.[2]?.subNodes?.[0] && fieldData?.['customisation-module-typography-text-alignment.vertical']?.[`customisation-module-typography-text-alignment-vertical.${keyPart}`]?.isDefault) {
                                        optionSubNode.subNodes[2].subNodes[0].booleanValue = true;
                                        optionSubNode.subNodes[2].subNodes[0].name = 'True';
                                    }
                                }
                            }
                        }
                    }
                }
            }
            break;

        case 'fill':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-fill-type') {
                    foundNonCustomField = true;
                    const fillTypeSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-fill-type');
                    if (fillTypeSubNode) {
                        fillTypeSubNode.name = fieldData?.name ?? 'Type Settings';
                        const unlinkedOptionSubNode = fillTypeSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-unlinked-value');
                        if (unlinkedOptionSubNode) {
                            unlinkedOptionSubNode.name = fieldData?.['customisation-module-fill-type-unlinked-value']?.name ?? '<User Editable Value>';
                            unlinkedOptionSubNode.enumValue = fieldData?.['customisation-module-fill-type-unlinked-value']?.enumValue ?? '<User Editable Value>';
                        }
                        
                        const solidOptionSubNode = fillTypeSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-solid');
                        if (solidOptionSubNode) {
                            solidOptionSubNode.name = fieldData?.['customisation-module-fill-type-solid']?.name ?? 'Solid';
                            const solidDataLinkSubNode = solidOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-solid-data-link');
                            if (solidDataLinkSubNode) {
                                solidDataLinkSubNode.name = fieldData?.['customisation-module-fill-type-solid']?.dataLink ? `<${fieldData['customisation-module-fill-type-solid']?.dataLink}>` : '<Not Linked>';
                                solidDataLinkSubNode.link = fieldData?.['customisation-module-fill-type-solid']?.dataLink ?? null;
                            }
                            const solidValueSubNode = solidOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-solid-value');
                            if (solidValueSubNode) {
                                solidValueSubNode.name = fieldData?.['customisation-module-fill-type-solid']?.value ?? '<No Value>';
                            }
                            const solidOptionOptionsSubNode = solidOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-solid-options');
                            if (solidOptionOptionsSubNode) {
                                const solidOptionKeys = ['color'];
                                for (let i = 0; i < solidOptionKeys.length; i++) {
                                    const key = solidOptionKeys[i];
                                    const optionSubNode = solidOptionOptionsSubNode.subNodes.find(node => node.id === `customisation-module-fill-type-solid-options-${key}`);
                                    if (optionSubNode) {
                                        optionSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-solid']?.["options"]?.[`customisation-module-fill-type-solid-options-${key}`]?.dataLink ?? null;
                                        optionSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-solid']?.["options"]?.[`customisation-module-fill-type-solid-options-${key}`]?.dataLink ? `<${fieldData['customisation-module-fill-type-solid']?.["options"]?.[`customisation-module-fill-type-solid-options-${key}`]?.dataLink}>` : '<Not Linked>';
                                    }
                                }
                            }
                        }

                        const gradientOptionSubNode = fillTypeSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-gradient');
                        if (gradientOptionSubNode) {
                            gradientOptionSubNode.name = fieldData?.['customisation-module-fill-type-gradient']?.name ?? 'Gradient';
                            const gradientDataLinkSubNode = gradientOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-gradient-data-link');
                            if (gradientDataLinkSubNode) {
                                gradientDataLinkSubNode.name = fieldData?.['customisation-module-fill-type-gradient']?.dataLink ? `<${fieldData['customisation-module-fill-type-gradient']?.dataLink}>` : '<Not Linked>';
                                gradientDataLinkSubNode.link = fieldData?.['customisation-module-fill-type-gradient']?.dataLink ?? null;
                            }
                            const gradientValueSubNode = gradientOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-gradient-value');
                            if (gradientValueSubNode) {
                                gradientValueSubNode.name = fieldData?.['customisation-module-fill-type-gradient']?.value ?? '<No Value>';
                            }
                            const gradientOptionOptionsSubNode = gradientOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-gradient-options');
                            if (gradientOptionOptionsSubNode) {
                                const gradientOptionKeys = ['color1', 'color2', 'angle'];
                                for (let i = 0; i < gradientOptionKeys.length; i++) {
                                    const key = gradientOptionKeys[i];
                                    const optionSubNode = gradientOptionOptionsSubNode.subNodes.find(node => node.id === `customisation-module-fill-type-gradient-options-${key}`);
                                    if (optionSubNode) {
                                        optionSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-gradient']?.["options"]?.[`customisation-module-fill-type-gradient-options-${key}`]?.dataLink ?? null;
                                        optionSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-gradient']?.["options"]?.[`customisation-module-fill-type-gradient-options-${key}`]?.dataLink ? `<${fieldData['customisation-module-fill-type-gradient']?.["options"]?.[`customisation-module-fill-type-gradient-options-${key}`]?.dataLink}>` : '<Not Linked>';
                                    }
                                }
                            }
                        }

                        const stripesOptionSubNode = fillTypeSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-stripes');
                        if (stripesOptionSubNode) {
                            stripesOptionSubNode.name = fieldData?.['customisation-module-fill-type-stripes']?.name ?? 'Stripes';
                            const stripesDataLinkSubNode = stripesOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-stripes-data-link');
                            if (stripesDataLinkSubNode) {
                                stripesDataLinkSubNode.name = fieldData?.['customisation-module-fill-type-stripes']?.dataLink ? `<${fieldData['customisation-module-fill-type-stripes']?.dataLink}>` : '<Not Linked>';
                                stripesDataLinkSubNode.link = fieldData?.['customisation-module-fill-type-stripes']?.dataLink ?? null;
                            }
                            const stripesValueSubNode = stripesOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-stripes-value');
                            if (stripesValueSubNode) {
                                stripesValueSubNode.name = fieldData?.['customisation-module-fill-type-stripes']?.value ?? '<No Value>';
                            }
                            const stripesOptionOptionsSubNode = stripesOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-stripes-options');
                            if (stripesOptionOptionsSubNode) {
                                const stripesOptionKeys = ['color1', 'color2', 'diagonal', 'straight', 'angle', 'width'];
                                for (let i = 0; i < stripesOptionKeys.length; i++) {
                                    const key = stripesOptionKeys[i];
                                    const optionSubNode = stripesOptionOptionsSubNode.subNodes.find(node => node.id === `customisation-module-fill-type-stripes-options-${key}`);
                                    if (optionSubNode) {
                                        if (key === 'diagonal' || key === 'straight') {
                                            optionSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.[`customisation-module-fill-type-stripes-options-${key}-data-link`]?.dataLink ?? null;
                                            optionSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.[`customisation-module-fill-type-stripes-options-${key}-data-link`]?.dataLink ? `<${fieldData['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.[`customisation-module-fill-type-stripes-options-${key}-data-link`]?.dataLink}>` : '<Not Linked>';
                                            optionSubNode.subNodes[1].name = fieldData?.['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.[`customisation-module-fill-type-stripes-options-${key}-value`]?.value ?? null ? `${fieldData['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.[`customisation-module-fill-type-stripes-options-${key}-value`]?.value}` : '<No Value>';
                                        } else {
                                            optionSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.dataLink ?? null;
                                            optionSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.dataLink ? `<${fieldData['customisation-module-fill-type-stripes']?.["options"]?.[`customisation-module-fill-type-stripes-options-${key}`]?.dataLink}>` : '<Not Linked>';
                                        }

                                    }
                                }
                            }
                        }

                        const imageOptionSubNode = fillTypeSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image');
                        if (imageOptionSubNode) {
                            imageOptionSubNode.name = fieldData?.['customisation-module-fill-type-image']?.name ?? 'Image';
                            const imageDataLinkSubNode = imageOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image-data-link');
                            if (imageDataLinkSubNode) {
                                imageDataLinkSubNode.name = fieldData?.['customisation-module-fill-type-image']?.dataLink ? `<${fieldData['customisation-module-fill-type-image']?.dataLink}>` : '<Not Linked>';
                                imageDataLinkSubNode.link = fieldData?.['customisation-module-fill-type-image']?.dataLink ?? null;
                            }
                            const imageValueSubNode = imageOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image-value');
                            if (imageValueSubNode) {
                                imageValueSubNode.name = fieldData?.['customisation-module-fill-type-image']?.value ?? '<No Value>';
                            }
                            const imageOptionOptionsSubNode = imageOptionSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image-options');
                            if (imageOptionOptionsSubNode) {
                                const selectImageOptionSubNode = imageOptionOptionsSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image-options-image');
                                if (selectImageOptionSubNode) {
                                    selectImageOptionSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-image`]?.dataLink ?? null;
                                    selectImageOptionSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-image`]?.dataLink ? `<${fieldData['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-image`]?.dataLink}>` : '<Not Linked>';
                                }
                                const fillStyleSubNode = imageOptionOptionsSubNode.subNodes.find(node => node.id === 'customisation-module-fill-type-image-options-fill-style');
                                if (fillStyleSubNode) {
                                    const fillTypeKeys = ['tile', 'contain', 'cover'];
                                    for (let i = 0; i < fillTypeKeys.length; i++) {
                                        const fillTypeKey = fillTypeKeys[i];
                                        const fillTypeSubNode = fillStyleSubNode.subNodes.find(node => node.id === `customisation-module-fill-type-image-options-${fillTypeKey}`);
                                        // console.log('Processing fill style option:', fillTypeKey, fillTypeSubNode);
                                        // console.log('Field data for fill style option:', fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-fill-style`] ?? null);
                                        if (fillTypeSubNode) {
                                            fillTypeSubNode.subNodes[0].link = fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-fill-style`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}-data-link`]?.dataLink ?? null;
                                            fillTypeSubNode.subNodes[0].name = fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-fill-style`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}-data-link`]?.dataLink ? `<${fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-fill-style`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}-data-link`]?.dataLink}>` : '<Not Linked>';
                                            fillTypeSubNode.subNodes[1].name = fieldData?.['customisation-module-fill-type-image']?.["options"]?.[`customisation-module-fill-type-image-options-fill-style`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}`]?.[`customisation-module-fill-type-image-options-${fillTypeKey}-value`]?.value ?? '<No Value>';
                                        }
                                    }
                                }

                            }
                        }

                    }
                } else if (fieldData.field === 'customisation-module-fill-opacity') {
                    foundNonCustomField = true;
                    const opacitySubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-fill-opacity');
                    if (opacitySubNode) {
                        opacitySubNode.name = fieldData?.name ?? 'Opacity';
                        opacitySubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        opacitySubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        case 'border':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-border-color') {
                    foundNonCustomField = true;
                    const colorSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-border-color');
                    if (colorSubNode) {
                        colorSubNode.name = fieldData?.name ?? 'Color';
                        colorSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        colorSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-border-opacity') {
                    foundNonCustomField = true;
                    const opacitySubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-border-opacity');
                    if (opacitySubNode) {
                        opacitySubNode.name = fieldData?.name ?? 'Opacity';
                        opacitySubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        opacitySubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-border-thickness') {
                    foundNonCustomField = true;
                    const thicknessSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-border-thickness');
                    if (thicknessSubNode) {
                        thicknessSubNode.name = fieldData?.name ?? 'Thickness';
                        thicknessSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        thicknessSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-border-position') {
                    foundNonCustomField = true;
                    const positionSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-border-position');
                    if (positionSubNode) {
                        const posKeys = ['inside', 'outside'];
                        positionSubNode.name = fieldData?.name ?? 'Position';
                        for (let i = 0; i < posKeys.length; i++) {
                            const key = posKeys[i];
                            const optionSubNode = positionSubNode.subNodes.find(node => node.id === `customisation-module-border-position-${key}`);
                            if (optionSubNode) {
                                optionSubNode.subNodes[0].link = fieldData?.['customisation-module-border-position']?.[`${key}`]?.dataLink ?? null;
                                optionSubNode.subNodes[0].name = fieldData?.['customisation-module-border-position']?.[`${key}`]?.dataLink ? `<${fieldData['customisation-module-border-position']?.[`customisation-module-border-position-${key}`]?.dataLink}>` : '<Not Linked>';
                                optionSubNode.subNodes[1].name = fieldData?.['customisation-module-border-position']?.[`${key}`]?.value ?? '<No Value>';
                            }
                        }
                    }
                }
            }
            break;

        case 'shadow':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else if (fieldData.field === 'customisation-module-shadow-color') {
                    foundNonCustomField = true;
                    const colorSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-shadow-color');
                    if (colorSubNode) {
                        colorSubNode.name = fieldData?.name ?? 'Color';
                        colorSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        colorSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-shadow-opacity') {
                    foundNonCustomField = true;
                    const opacitySubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-shadow-opacity');
                    if (opacitySubNode) {
                        opacitySubNode.name = fieldData?.name ?? 'Opacity';
                        opacitySubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        opacitySubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-shadow-blur') {
                    foundNonCustomField = true;
                    const blurSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-shadow-blur');
                    if (blurSubNode) {
                        blurSubNode.name = fieldData?.name ?? 'Blur';
                        blurSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        blurSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-shadow-spread') {
                    foundNonCustomField = true;
                    const spreadSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-shadow-spread');
                    if (spreadSubNode) {
                        spreadSubNode.name = fieldData?.name ?? 'Spread';
                        spreadSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        spreadSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                } else if (fieldData.field === 'customisation-module-shadow-position') {
                    foundNonCustomField = true;
                    const positionSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-shadow-position');
                    if (positionSubNode) {
                        const posKeys = ['x', 'y'];
                        positionSubNode.name = fieldData?.name ?? 'Position';
                        for (let i = 0; i < posKeys.length; i++) {
                            const key = posKeys[i];
                            const optionSubNode = positionSubNode.subNodes.find(node => node.id === `customisation-module-shadow-position-${key}`);
                            if (optionSubNode) {
                                optionSubNode.subNodes[0].link = fieldData?.[`customisation-module-shadow-position-${key}`]?.dataLink ?? null;
                                optionSubNode.subNodes[0].name = fieldData?.[`customisation-module-shadow-position-${key}`]?.dataLink ? `<${fieldData[`customisation-module-shadow-position-${key}`]?.dataLink}>` : '<Not Linked>';
                            }
                        }
                    }
                }
            }
            break;
        
        case 'padding':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else {
                    const field = fieldData.field;
                    const paddingSubNode = moduleNode.subNodes.find(node => node.id === field);
                    if (paddingSubNode) {
                        foundNonCustomField = true;
                        paddingSubNode.name = fieldData?.name ?? paddingSubNode.name;
                        paddingSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        paddingSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;
        
        case 'copy':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    // if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    // } else {
                        // moduleNode.subNodes.unshift(newFieldNodeData);
                    // }
                }
            }
            const dataLinkSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-copy-data-link');
            if (dataLinkSubNode) {
                dataLinkSubNode.link = moduleData?.['dataLink'] ?? null;
                dataLinkSubNode.name = moduleData?.['dataLink'] ? `<${moduleData['dataLink']}>` : '<Not Linked>';
            }
            const multilineSubNode = moduleNode.subNodes.find(node => node.id === 'customisation-module-copy-multi-line');
            if (multilineSubNode) {
                multilineSubNode.subNodes[0].enumValue = (moduleData?.['multiline'] ?? false) ? 'multi' : 'single';
                multilineSubNode.subNodes[0].name = (moduleData?.['multiline'] ?? false) ? 'multi' : 'single';
            }
            break;
        
        case 'animation':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else {
                    const field = fieldData.field;
                    const animSubNode = moduleNode.subNodes.find(node => node.id === field);
                    if (animSubNode) {
                        foundNonCustomField = true;
                        animSubNode.name = fieldData?.name ?? animSubNode.name;
                        animSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        animSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        case 'audio':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else {
                    const field = fieldData.field;
                    const audioSubNode = moduleNode.subNodes.find(node => node.id === field);
                    if (audioSubNode) {
                        foundNonCustomField = true;
                        audioSubNode.name = fieldData?.name ?? audioSubNode.name;
                        audioSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        audioSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        case 'disruptor':
            // Loop over the fields as we can have custom fields before and after the module fields
            for (let i = 0; i < moduleData.fields.length; i++) {
                fieldData = moduleData.fields[i];
                if (fieldData.field === 'customCustomisationField') {
                    // A custom field, we can process it the same way as in the custom module
                    const newFieldNodeData = processCustomFieldDataObjectToNodes(fieldData);
                    if (foundNonCustomField) {
                        moduleNode.subNodes.push(newFieldNodeData);
                    } else {
                        firstCustomFieldBlock.push(newFieldNodeData);
                    }
                } else {
                    const field = fieldData.field;
                    const disruptorSubNode = moduleNode.subNodes.find(node => node.id === field);
                    if (disruptorSubNode) {
                        foundNonCustomField = true;
                        disruptorSubNode.name = fieldData?.name ?? disruptorSubNode.name;
                        disruptorSubNode.subNodes[0].link = fieldData?.dataLink ?? null;
                        disruptorSubNode.subNodes[0].name = fieldData?.dataLink ? `<${fieldData.dataLink}>` : '<Not Linked>';
                    }
                }
            }
            break;

        default:
            break;
    }

    if (firstCustomFieldBlock.length > 0) {
        // We have custom fields that need to be added at the start of the field list, we can add them now
        moduleNode.subNodes = [...firstCustomFieldBlock, ...moduleNode.subNodes];
    }

    const addCustomFieldNode = {...addCustomFieldButton};
    moduleNode.subNodes.push(addCustomFieldNode);

    return moduleNode;
}

const processCustomFieldDataObjectToNodes = (fieldData) => {
    const newFieldNodeData = JSON.parse(JSON.stringify(BLANK_STRUCTURES.customCustomisationField));
                
    newFieldNodeData.name = fieldData.name;
    const uid = generateUniqueId();
    newFieldNodeData.id = newFieldNodeData.id + '-' + fieldData.name.toLowerCase().replace(/\s+/g, '-' + uid);
    newFieldNodeData.path = newFieldNodeData.path + '.' + fieldData.name.toLowerCase().replace(/\s+/g, '-' + uid);

    console.log('Processing custom field: ', fieldData, ' into node: ', newFieldNodeData);

    const cf_typeSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-type');
    if (cf_typeSubNode) {
        cf_typeSubNode.name = fieldData.customFieldConfig.customFieldType;
        newFieldNodeData.type = fieldData.customFieldConfig.customFieldType;
    }
    const cf_nameSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-name-content');
    if (cf_nameSubNode) {
        cf_nameSubNode.name = fieldData.customFieldConfig?.customFieldLabel ?? '<Use Default Label>';
    }
    const cf_linkSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-name-data-link');
    if (cf_linkSubNode) {
        cf_linkSubNode.name = fieldData.customFieldConfig?.dataLink ?? '<Not Linked>';
        cf_linkSubNode.link = fieldData.customFieldConfig?.dataLink ?? null;
    }
    const cf_fixedValueSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-fix-value');
    if (cf_fixedValueSubNode) {
        cf_fixedValueSubNode.subNodes[0].name = fieldData.customFieldConfig?.fixedValue ?? '<User Editable Value>';
    }
    const cf_fieldShownSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-shown');
    if (cf_fieldShownSubNode) {
        cf_fieldShownSubNode.subNodes[0].booleanValue = fieldData.customFieldConfig?.isShown ?? true;
        cf_fieldShownSubNode.subNodes[0].name = (fieldData.customFieldConfig?.isShown ?? true) ? 'True' : 'False';
    }
    const cf_fieldWideSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-wide');
    if (cf_fieldWideSubNode) {
        cf_fieldWideSubNode.subNodes[0].booleanValue = fieldData.customFieldConfig?.isWide ?? false;
        cf_fieldWideSubNode.subNodes[0].name = (fieldData.customFieldConfig?.isWide ?? false) ? 'True' : 'False';
    }
    const cf_fieldOnValueSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-on-value');
    if (cf_fieldOnValueSubNode) {
        cf_fieldOnValueSubNode.subNodes[0].name = fieldData.customFieldConfig.onValue ?? '<Default Value>';
    }
    const cf_fieldOffValueSubNode = newFieldNodeData.subNodes.find(node => node.id === 'customisation-custom-field-off-value');
    if (cf_fieldOffValueSubNode) {
        cf_fieldOffValueSubNode.subNodes[0].name = fieldData.customFieldConfig.offValue ?? '<Default Value>';
    }

    return newFieldNodeData;
}

const processExportedConfigDataObjectTimelineToNodes = (dataObject, nodesObject) => {
    // Extract timeline data from the data object and populate the nodes object
    const exportedTimelineData = dataObject.timeline;
    // Find timeline node in nodesObject
    const timelineNode = nodesObject.subNodes.find(node => node.id === 'timeline');
    if (timelineNode) {
        // Process steps
        const timelineStepsNode = timelineNode.subNodes.find(node => node.id === 'timeline-steps');
        if (timelineStepsNode) {
            // First remove any existing steps (except the add button)
            timelineStepsNode.subNodes = timelineStepsNode.subNodes.filter(node => node.isAddButton);
            exportedTimelineData.steps.forEach(stepName => {
                const stepNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.step));
                stepNode.id = `timeline-step-${stepName.toLowerCase().replace(/\s+/g, '-')}`;
                stepNode.path = `timeline.steps.${stepName.toLowerCase().replace(/\s+/g, '-')}`;
                stepNode.name = stepName;
                timelineStepsNode.subNodes.push(stepNode);
            });
            // Move the add button to the end of the list
            const addButtonNode = timelineStepsNode.subNodes.find(node => node.isAddButton);
            if (addButtonNode) {
                timelineStepsNode.subNodes = timelineStepsNode.subNodes.filter(node => !node.isAddButton);
                timelineStepsNode.subNodes.push(addButtonNode);
            }
        }
        // Process audio groups
        const timelineAudioNode = timelineNode.subNodes.find(node => node.id === 'timeline-audio');
        if (timelineAudioNode) {
            // First remove any existing audio groups (except the add button)
            timelineAudioNode.subNodes = timelineAudioNode.subNodes.filter(node => node.isAddButton);
            exportedTimelineData.audioGroups.forEach(audioGroup => {
                const audioGroupNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.audioGroup));
                audioGroupNode.id = `timeline-audio-${audioGroup.name.toLowerCase().replace(/\s+/g, '-')}`;
                audioGroupNode.name = audioGroup.name;
                audioGroupNode.path = `timeline.audio.${audioGroup.name.toLowerCase().replace(/\s+/g, '-')}`;
                audioGroup.audios.forEach(audio => {
                    const audioNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.timelineAudio));
                    audioNode.id = `timeline-audio-${audio.name.toLowerCase().replace(/\s+/g, '-')}`;
                    audioNode.path = `timeline.audio.${audioGroup.name.toLowerCase().replace(/\s+/g, '-')}.${audio.name.toLowerCase().replace(/\s+/g, '-')}`;
                    audioNode.name = audio.name;
                    // Process audio fields
                    for (const key in audio) {
                        if (key !== 'name' && key !== 'type' && key !== 'module') {
                            // The subnode will already exist, so let's find it and update it rather than creating a new one
                            const audioSubNode = audioNode.subNodes.find(node => node.id === key);
                            if (key === 'trigger-step' || key === 'end-step') {
                                audioSubNode.subNodes[0].dynamicLinkedIndex = audio[key];
                            } else {
                                if (audio[key]) {
                                    audioSubNode.subNodes[0].link = audio[key];
                                    audioSubNode.subNodes[0].name = `<${audio[key]}>`; // Set the name to show the linked value
                                }
                            }
                        }
                    }
                    audioGroupNode.subNodes.push(audioNode);
                });
                // Move the add button to the end of the list
                let addButtonNode = audioGroupNode.subNodes.find(node => node.isAddButton);
                if (addButtonNode) {
                    audioGroupNode.subNodes = audioGroupNode.subNodes.filter(node => !node.isAddButton);
                    audioGroupNode.subNodes.push(addButtonNode);
                }
                timelineAudioNode.subNodes.push(audioGroupNode);
                // Move the add button to the end of the list
                addButtonNode = timelineAudioNode.subNodes.find(node => node.isAddButton);
                if (addButtonNode) {
                    timelineAudioNode.subNodes = timelineAudioNode.subNodes.filter(node => !node.isAddButton);
                    timelineAudioNode.subNodes.push(addButtonNode);
                }
            });
        }
        // Process disruptor groups
        const timelineDisruptorsNode = timelineNode.subNodes.find(node => node.id === 'timeline-disruptors');
        if (timelineDisruptorsNode) {
            // First remove any existing disruptor groups (except the add button)
            timelineDisruptorsNode.subNodes = timelineDisruptorsNode.subNodes.filter(node => node.isAddButton);
            exportedTimelineData.disruptorGroups.forEach(disruptorGroup => {
                const disruptorGroupNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.disruptorGroup));
                disruptorGroupNode.id = `timeline-disruptors-${disruptorGroup.name.toLowerCase().replace(/\s+/g, '-')}`;
                disruptorGroupNode.name = disruptorGroup.name;
                disruptorGroupNode.path = `timeline.disruptors.${disruptorGroup.name.toLowerCase().replace(/\s+/g, '-')}`;
                disruptorGroup.disruptors.forEach(disruptor => {
                    const disruptorNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.timelineDisruptor));
                    disruptorNode.id = `timeline-disruptor-${disruptor.name.toLowerCase().replace(/\s+/g, '-')}`;
                    disruptorNode.path = `timeline.disruptors.${disruptorGroup.name.toLowerCase().replace(/\s+/g, '-')}.${disruptor.name.toLowerCase().replace(/\s+/g, '-')}`;
                    disruptorNode.name = disruptor.name;
                    // Process disruptor fields
                    for (const key in disruptor) {
                        if (key !== 'name' && key !== 'type' && key !== 'module') {
                            // The subnode will already exist, so let's find it and update it rather than creating a new one
                            const disruptorSubNode = disruptorNode.subNodes.find(node => node.id === key);
                            if (key === 'trigger-step' || key === 'end-step') {
                                disruptorSubNode.subNodes[0].dynamicLinkedIndex = disruptor[key];
                            } else {
                                if (disruptor[key]) {
                                    disruptorSubNode.subNodes[0].link = disruptor[key];
                                    disruptorSubNode.subNodes[0].name = `<${disruptor[key]}>`; // Set the name to show the linked value
                                }
                            }
                        }
                    }
                    disruptorGroupNode.subNodes.push(disruptorNode);
                });
                // Move the add button to the end of the list
                let addButtonNode = disruptorGroupNode.subNodes.find(node => node.isAddButton);
                if (addButtonNode) {
                    disruptorGroupNode.subNodes = disruptorGroupNode.subNodes.filter(node => !node.isAddButton);
                    disruptorGroupNode.subNodes.push(addButtonNode);
                }
                timelineDisruptorsNode.subNodes.push(disruptorGroupNode);
                // Move the add button to the end of the list
                addButtonNode = timelineDisruptorsNode.subNodes.find(node => node.isAddButton);
                if (addButtonNode) {
                    timelineDisruptorsNode.subNodes = timelineDisruptorsNode.subNodes.filter(node => !node.isAddButton);
                    timelineDisruptorsNode.subNodes.push(addButtonNode);
                }
            });
        }
    }
}
    

/*
    * Processes the nodes to a final data object format.
    * This function iterates through the nodes and processes them based on their depth and type.
    * It returns a structured object containing the feature ID, name, and timeline data.
    * 
    * This function is pretty kludgy and horrible!
    * It's supposed to eliminate the need to have a separate function for each type of module.
    * It works in 90% of cases, but there are some module-specific cases that are handled by their own functions,
    * (see MODULE_SPECIFIC_OUTBOUND_PROCESSORS)
    * 
    * It ended up so kludgy because I was trying to fix bugs with some modules that had specific requirements,
    * I eventually decided the one-size fits all approach was not going to work, and ended up making the module specific functions to handle some of them.
    * 
    * Processing this the other way (ie. loading in workspace config json data for editing) will probably always be module specific.
    * Plus the modules themselves will be React components that understand the specific data structure for that module.
    * 
    * In any case this is an internal tool for the timeline builder, so it doesn't need to be perfect.
    * If we add new modules, we should test the output and decide whether we need to add a specific processor for that module.
    * Each modules confguration is detailed in the CUSTOMISATION_MODULES object (and commented), 
    * so we can easily add new modules and their specific processors.
    * 
    * - Carl
*/
export const processNodesToFinalDataObject = (nodes, configDataNode = null) => {
    console.log('Processing nodes to final data object. Nodes:', nodes, 'ConfigDataNode:', configDataNode);
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        console.log('Processing node:', node);
        if (node.depth === 0 && (configDataNode === null || node === configDataNode)) {
            const processedData = {
                featureKey: node.featureKey || node?.featureData?.feature?.featureKey || node.featureId,
                featureName: node.name,
                timeline: {
                    steps: [],
                    audioGroups: [],
                    disruptorGroups: []
                }
            };
            for (let j = 0; j < node.subNodes.length; j++) {
                const subNode = node.subNodes[j];
                if (subNode.id === 'timeline') {
                    // Process timeline nodes
                    processedData.timeline = processTimelineNodeToFinalDataObject(subNode);
                } else
                if (subNode.id === 'customisation') {
                    // Process customisation nodes
                    processedData.customisation = processCustomisationGroupsToFinalDataObject(subNode);
                }
            }
            return processedData;
        }
    }

    // Default to the first node if no depth 0 node found that matches the originally passed configDataNode
    return processNodesToFinalDataObject(nodes);
};
const processTimelineNodeToFinalDataObject = (timelineNode) => {
    const timelineData = {
        steps: [],
        audioGroups: [],
        disruptorGroups: []
    };
    for (let i = 0; i < timelineNode.subNodes.length; i++) {
        const subNode = timelineNode.subNodes[i];
        if (subNode.id === 'timeline-steps') {
            // Process steps
            for (let j = 0; j < subNode.subNodes.length; j++) {
                const stepNode = subNode.subNodes[j];
                if (stepNode.id !== 'timeline-steps-add') {
                    timelineData.steps.push(stepNode.name);
                }
            }
        } else if (subNode.id === 'timeline-audio') {
            // Process audio groups
            for (let j = 0; j < subNode.subNodes.length; j++) {
                const audioGroupNode = subNode.subNodes[j];
                if (audioGroupNode.id !== 'timeline-audio-group-add') {
                    const audioGroupData = {
                        name: audioGroupNode.name,
                        type: 'audioGroup',
                        audios: []
                    };
                    for (let k = 0; k < audioGroupNode.subNodes.length; k++) {
                        const audioNode = audioGroupNode.subNodes[k];
                        if (audioNode.id !== 'timeline-audio-add') {
                            const audioData = {
                                name: audioNode.name,
                                type: 'module',
                                module: 'timelineAudio',
                            };
                            for (let l = 0; l < audioNode.subNodes.length; l++) {
                                const audioSubNode = audioNode.subNodes[l];
                                if (audioSubNode.id === 'audio-enabled') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                } else if (audioSubNode.id === 'audio-name') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                } else if (audioSubNode.id === 'audio-file') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                } else if (audioSubNode.id === 'audio-loop') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                }else if (audioSubNode.id === 'audio-volume') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                } else if (audioSubNode.id === 'audio-delay') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].link;
                                } else if (audioSubNode.id === 'trigger-step') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].dynamicLinkedIndex;
                                } else if (audioSubNode.id === 'end-step') {
                                    audioData[audioSubNode.id] = audioSubNode.subNodes[0].dynamicLinkedIndex;
                                }
                            }
                            audioGroupData.audios.push(audioData);
                        }
                    }
                    timelineData.audioGroups.push(audioGroupData);
                }
            }
        } else if (subNode.id === 'timeline-disruptors') {
            // Process disruptor groups
            for (let j = 0; j < subNode.subNodes.length; j++) {
                const disruptorGroupNode = subNode.subNodes[j];
                if (disruptorGroupNode.id !== 'timeline-disruptors-group-add') {
                    const disruptorGroupData = {
                        name: disruptorGroupNode.name,
                        type: 'disruptorGroup',
                        disruptors: []
                    };
                    for (let k = 0; k < disruptorGroupNode.subNodes.length; k++) {
                        const disruptorNode = disruptorGroupNode.subNodes[k];
                        if (disruptorNode.id !== 'timeline-disruptors-add') {
                            const disruptorData = {
                                name: disruptorNode.name,
                                type: 'module',
                                module: 'timelineDisruptor',
                            };
                            for (let l = 0; l < disruptorNode.subNodes.length; l++) {
                                const disruptorSubNode = disruptorNode.subNodes[l];
                                if (disruptorSubNode.id === 'disruptor-enabled') {
                                    disruptorData[disruptorSubNode.id] = disruptorSubNode.subNodes[0].link;
                                } else if (disruptorSubNode.id === 'disruptor-select') {
                                    disruptorData[disruptorSubNode.id] = disruptorSubNode.subNodes[0].link;
                                } else if (disruptorSubNode.id === 'disruptor-wait-for-end') {
                                    disruptorData[disruptorSubNode.id] = disruptorSubNode.subNodes[0].link;
                                } else if (disruptorSubNode.id === 'trigger-step') {
                                    disruptorData[disruptorSubNode.id] = disruptorSubNode.subNodes[0].dynamicLinkedIndex;
                                } else if (disruptorSubNode.id === 'end-step') {
                                    disruptorData[disruptorSubNode.id] = disruptorSubNode.subNodes[0].dynamicLinkedIndex;
                                }
                            }
                            disruptorGroupData.disruptors.push(disruptorData);
                        }
                    }
                    timelineData.disruptorGroups.push(disruptorGroupData);
                }
            }
        }
    }
    return timelineData;
}
const processCustomisationGroupsToFinalDataObject = (customisationNode) => {
    const customisationData = {
        groups: []
    };
    for (let i = 0; i < customisationNode.subNodes.length; i++) {
        const subNode = customisationNode.subNodes[i];
        if (subNode.customisationContainerType === 'group') {
            const groupData = processOneCustomisationGroupToFinalDataObject(subNode);
            customisationData.groups.push(groupData);
        }
    }
    return customisationData;
}
const processOneCustomisationGroupToFinalDataObject = (customisationNode) => {
    const groupData = {
        name: customisationNode.name,
        type: 'group',
        children: [],
        visualisationConfig: null,
        groupSettings: null,
    }
    // Step through the subNodes of the customisation node
    // Process each field below, for visualisation we will have a special function and for groups we call the same function recursively
    for (let i = 0; i < customisationNode.subNodes.length; i++) {
        const subNode = customisationNode.subNodes[i];
        // console.log("Flattening subNode: ", subNode);
        // Module, group or visualisation settings at this level
        if (subNode.customisationContainerType === 'module') {
            let moduleType = subNode.id.includes('module-custom') ? 'custom' : null;
            if (moduleType === null) {
                // Find the module type, the start of the id should match an id in CUSTOMISATION_MODULES
                for (const key in CUSTOMISATION_MODULES) {
                    if (subNode.id.startsWith(CUSTOMISATION_MODULES[key].id)) {
                        moduleType = key;
                        break;
                    }
                }
            }
            if (moduleType) {
                if (MODULE_SPECIFIC_OUTBOUND_PROCESSORS[moduleType]) {
                    // If there is a specific processor for this module, use it
                    const moduleData = MODULE_SPECIFIC_OUTBOUND_PROCESSORS[moduleType](subNode);
                    addModuleSettingsToModuleData(moduleData, subNode);
                    groupData.children.push(moduleData);
                    continue; // Skip the rest of the processing for this module
                }

                const moduleData = {
                    name: subNode.name,
                    type: 'module',
                    module: moduleType,
                    fields: [],
                };
                for (let j = 0; j < subNode.subNodes.length; j++) {
                    // Fist ignore description nodes and isAddButton nodes
                    if (subNode.subNodes[j].id.includes('-description') || subNode.subNodes[j].isAddButton || subNode.subNodes[j].id === 'module-config') {
                        continue;
                    }
                    const fieldNode = subNode.subNodes[j];
                    let fieldData = {
                        name: fieldNode.name,
                        type: 'field',
                    }
                    // Is this a custom field?
                    if (fieldNode.customisationContainerType === 'field' && fieldNode.id.includes('custom-field')) {
                        // This is a custom field
                        fieldData.field = 'customCustomisationField';
                        // Step through the subNodes for the custom field and extract the type and value
                        const customFieldConfig = processCustomFieldConfig(fieldNode);
                        fieldData.customFieldConfig = customFieldConfig;
                    } else if (fieldNode.path === 'data-link') {
                        fieldData = {dataLink: fieldNode.link};
                    } else {
                        // Otherwise, it's a regular module field
                        fieldData.field = fieldNode.id; // Use the id as the field name
                        // Step through the subNodes for the field and extract the relevant data
                        for (let k = 0; k < fieldNode.subNodes.length; k++) {
                            console.log("Processing field subNode: ", fieldNode.subNodes[k]);
                            if (fieldNode.subNodes[k].valueLink) {
                                fieldData.value = fieldNode.subNodes[k].name !== '<No Value>' ? (fieldNode.subNodes[k].value ?? fieldNode.subNodes[k].name) : null;
                            } else
                            if (fieldNode.subNodes[k].path === 'data-link') {
                                fieldData.dataLink = fieldNode.subNodes[k].link;
                                // console.log("NO NEED TO PUSH FIELD DATA! Found data link in fieldNode: ", fieldNode.subNodes[k]);
                                continue; // We don't need to push the field data if we have a data link
                            } else {
                                // If the id contains the mis-spelt "dimentions", correct it
                                if (fieldNode.subNodes[k].id.includes('dimentions')) {
                                    fieldNode.subNodes[k].id = fieldNode.subNodes[k].id.replace('dimentions', 'dimensions');
                                    fieldData.field = fieldNode.id; // Use the id as the field name
                                }

                                if (fieldNode.subNodes[k]?.subNodes?.length === 1 && fieldNode.subNodes[k].subNodes[0].valueLink) {
                                    fieldData[fieldNode.subNodes[k].subNodes[0].id] = fieldNode.subNodes[k].subNodes[0].name !== '<No Value>' ? fieldNode.subNodes[k].subNodes[0].name : null;
                                } else 
                                /* if (fieldNode.subNodes[k].subNodes.length === 2 && ((fieldNode.subNodes[k].subNodes[0].path === 'data-link' && fieldNode.subNodes[k].subNodes[1].valueLink) || (fieldNode.subNodes[k].subNodes[1].path === 'data-link' && fieldNode.subNodes[k].subNodes[0].valueLink))) {
                                    // This is a special case where we have a data link and a value link
                                    if (fieldNode.subNodes[k].subNodes[0].path === 'data-link') {
                                        fieldData.dataLink = fieldNode.subNodes[k].subNodes[0].link;
                                        fieldData.value = fieldNode.subNodes[k].subNodes[1].name !== '<No Value>' ? (fieldNode.subNodes[k].subNodes[1].value ?? fieldNode.subNodes[k].subNodes[1].name) : null;
                                    } else {
                                        fieldData.dataLink = fieldNode.subNodes[k].subNodes[1].link;
                                        fieldData.value = fieldNode.subNodes[k].subNodes[0].name !== '<No Value>' ? (fieldNode.subNodes[k].subNodes[0].value ?? fieldNode.subNodes[k].subNodes[0].name) : null;
                                    }
                                } else
                                if (fieldNode.subNodes[k].subNodes.length === 2 && ((fieldNode.subNodes[k].subNodes[0].path === 'data-link' && fieldNode.subNodes[k].subNodes[1].isEnum) || (fieldNode.subNodes[k].subNodes[1].path === 'data-link' && fieldNode.subNodes[k].subNodes[0].isEnum))) {
                                    // This is a special case where we have a data link and an enum value
                                    if (fieldNode.subNodes[k].subNodes[0].path === 'data-link') {
                                        fieldData.dataLink = fieldNode.subNodes[k].subNodes[0].link;
                                        fieldData[fieldNode.subNodes[k].subNodes[1].id] = fieldNode.subNodes[k].subNodes[1].enumValue ?? fieldNode.subNodes[k].subNodes[1].enumDefault;
                                    } else {
                                        fieldData.dataLink = fieldNode.subNodes[k].subNodes[1].link;
                                        fieldData[fieldNode.subNodes[k].subNodes[0].id] = fieldNode.subNodes[k].subNodes[0].enumValue ?? fieldNode.subNodes[k].subNodes[0].enumDefault;
                                    }
                                } else */
                                if (subNode.isBoolean) {
                                    fieldData[fieldNode.subNodes[k].subNodes[0].id] = subNode.booleanValue;
                                } else 
                                if (subNode.isEnum) {
                                    fieldData[fieldNode.subNodes[k].subNodes[0].id] = subNode.enumValue ?? subNode.enumDefault;
                                } else {
                                    processModuleFieldConfig(fieldNode.subNodes[k], fieldData);
                                }
                            }
                        }
                    }
                    moduleData.fields.push(fieldData);
                }
                addModuleSettingsToModuleData(moduleData, subNode);
                groupData.children.push(moduleData);
            }
        } else if (subNode.customisationContainerType === 'group') {
            // Process nested group recursively
            const nestedGroupData = processOneCustomisationGroupToFinalDataObject(subNode);
            groupData.children.push(nestedGroupData);
        } else if (subNode.id === 'customisation-group-visualisation-settings') {
            // Process visualisation settings
            groupData.visualisationConfig = processVisualisationConfigForFinalDataObject(subNode);
        } else if (subNode.id === 'group-config') {
            // Process group config
            groupData.groupSettings = processGroupConfigForFinalDataObject(subNode);
        }
    }

    return groupData;
}
const processBasicSubNodes = (fieldNode) => {
    const fieldData = {};
    for (let i = 0; i < fieldNode.subNodes.length; i++) {
        const subNode = fieldNode.subNodes[i];
        fieldData[subNode.id] = {};
        // console.log(">>> processBasicSubNodes Flattening subNode: ", subNode);
        if (subNode.path === 'data-link') {
            fieldData[subNode.id].dataLink = subNode.link;
        } else if (subNode.isBoolean) {
            fieldData[subNode.id]['value'] = subNode.booleanValue;
        } else if (subNode.isEnum) {
            fieldData[subNode.id]['value'] = subNode.enumValue ?? subNode.enumDefault;
        } else if (subNode.valueLink) {
            // If the subnode has a value link, we can assume it's a value node
            fieldData[subNode.id]['value'] = subNode.name !== '<No Value>' ? subNode.name : null;
        } else {
            if (subNode.subNodes && subNode.subNodes.length === 1) {
                if (subNode.subNodes[0].valueLink) {
                    fieldData[subNode.id]['value'] = subNode.subNodes[0].name !== '<No Value>' ? (subNode.subNodes[0].name) : null;
                } else if (subNode.subNodes[0].isBoolean) {
                    fieldData[subNode.id]['value'] = subNode.subNodes[0].booleanValue;
                } else if (subNode.subNodes[0].isEnum) {
                    fieldData[subNode.id]['value'] = subNode.subNodes[0].enumValue !== '<User Editable Value>' ? (subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault) : null;
                } else if (subNode.subNodes[0].path === 'data-link') {
                    fieldData[subNode.id]['dataLink'] = subNode.subNodes[0].link;
                }
            }/*  else
            if (subNode.subNodes && subNode.subNodes.length === 2) {
                // There is a specific subnode format that has two children that consists of data-link and a value link
                if (subNode.subNodes[0].path === 'data-link' && subNode.subNodes[1].valueLink) {
                    // console.log("Processing special [2] case for subNode: ", subNode);
                    // This is a special case where we have a data link and a value link
                    fieldData[subNode.id]['dataLink'] = subNode.subNodes[0].link;
                    fieldData[subNode.id]['value'] = subNode.subNodes[1].name !== '<No Value>' ? subNode.subNodes[1].name : null;
                } else 
                if (subNode.subNodes[1].path === 'data-link' && subNode.subNodes[0].valueLink) {
                    // console.log("Processing special [2] case for subNode: ", subNode);
                    // This is a special case where we have a data link and a value link
                    fieldData[subNode.id]['dataLink'] = subNode.subNodes[1].link;
                    fieldData[subNode.id]['value'] = subNode.subNodes[0].name !== '<No Value>' ? subNode.subNodes[0].name : null;
                } else
                if (subNode.subNodes[0].path === 'data-link' && subNode.subNodes[1].isEnum) {
                    // console.log("Processing special [2] case for subNode: ", subNode);
                    // This is a special case where we have a data link and an enum value
                    fieldData[subNode.id]['dataLink'] = subNode.subNodes[0].link;
                    fieldData[subNode.id]['value'] = subNode.subNodes[1].enumValue ?? subNode.subNodes[1].enumDefault;
                } else
                if (subNode.subNodes[1].path === 'data-link' && subNode.subNodes[0].isEnum) {
                    // console.log("Processing special [2] case for subNode: ", subNode);
                    // This is a special case where we have a data link and an enum value
                    fieldData[subNode.id]['dataLink'] = subNode.subNodes[1].link;
                    fieldData[subNode.id]['value'] = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
                }
            } */
        }
        if (Object.keys(fieldData[subNode.id]).length === 0) {
            // Nothing fulfilled our conditions, so we assume it's a complex node and we need to process it recursively
            fieldData[subNode.id] = processBasicSubNodes(subNode);
        }
    }
    // console.log(">>> processBasicSubNodes Flattened fieldData: ", fieldData);
    return fieldData;
}

const processCustomFieldConfig = (fieldNode) => {
    const customFieldConfig = {};
    for (let k = 0; k < fieldNode.subNodes.length; k++) {
        const customFieldSubNode = fieldNode.subNodes[k];
        // console.log("Flattening custom field subNode: ", customFieldSubNode);
        switch (customFieldSubNode.id) {
            case 'customisation-custom-field-type':
                customFieldConfig.customFieldType = fieldNode.type;
                break;
            case 'customisation-custom-field-name-content':
                customFieldConfig.customFieldLabel = customFieldSubNode.name !== '<Use Default Label>' ? customFieldSubNode.name : null;
                break;
            case 'customisation-custom-field-name-data-link':
                customFieldConfig.dataLink = customFieldSubNode.link;
                break;
            case 'customisation-custom-field-fix-value':
                customFieldConfig.fixedValue = customFieldSubNode.subNodes[0].name !== '<User Editable Value>' ? (customFieldSubNode.subNodes[0].value ?? customFieldSubNode.subNodes[0].name) : null;
                break;
            case 'customisation-custom-field-shown':
                customFieldConfig.isShown = customFieldSubNode.subNodes[0].booleanValue;
                break;
            case 'customisation-custom-field-wide':
                customFieldConfig.isWide = customFieldSubNode.subNodes[0].booleanValue;
                break;
            case 'customisation-custom-field-on-value':
                customFieldConfig.onValue = customFieldSubNode.subNodes[0].name !== '<Default Value>' ? (customFieldSubNode.subNodes[0].value ?? customFieldSubNode.subNodes[0].name) : null;
                break;
            case 'customisation-custom-field-off-value':
                customFieldConfig.offValue = customFieldSubNode.subNodes[0].name !== '<Default Value>' ? (customFieldSubNode.subNodes[0].value ?? customFieldSubNode.subNodes[0].name) : null;
                break;
            default:
                break; // Ignore other nodes for now
        }
    }
    return customFieldConfig;
}
// We sometimes need to recursively process a module field config, this is where we do that
const processModuleFieldConfig = (fieldNode, fieldData) => {
    // console.log("Processing module field config for node: ", fieldNode);
    fieldData[fieldNode.id] = {
        name: fieldNode.name
    }
    if (fieldNode.subNodes && fieldNode.subNodes.length > 0) {
        if (fieldNode.subNodes.length === 3 && fieldNode.subNodes[0].path === 'data-link' && fieldNode.subNodes[1].valueLink && fieldNode.subNodes[2].name === 'Options') {
            // console.log("Processing special [3] case for subNode: ", fieldNode);
            // This is a special case where we have a data link and a value link with options
            fieldData[fieldNode.id].dataLink = fieldNode.subNodes[0].link;
            fieldData[fieldNode.id].value = fieldNode.subNodes[1].name !== '<No Value>' ? (fieldNode.subNodes[1].value ?? fieldNode.subNodes[1].name) : null
            // Process the options
            fieldData[fieldNode.id].options = processBasicSubNodes(fieldNode.subNodes[2]);
        } else
        for (let i = 0; i < fieldNode.subNodes.length; i++) {
            const subNode = fieldNode.subNodes[i];
            if (subNode.valueLink) {
                fieldData[fieldNode.id].value = subNode.name !== '<No Value>' ? (subNode.value ?? subNode.name) : null;
            } else
            if (subNode.path === 'data-link') {
                fieldData[fieldNode.id].dataLink = subNode.link;
            } else if (subNode.isBoolean) {
                fieldData[fieldNode.id][subNode.id] = subNode.booleanValue;
            } else if (subNode.isEnum) {
                fieldData[fieldNode.id][subNode.id] = subNode.enumValue ?? subNode.enumDefault;
            } else {
                // If the subnode has a single child node, we can assume it's a value node
                /* if (subNode.subNodes && subNode.subNodes.length === 3 && subNode.subNodes[0].path === 'data-link' && subNode.subNodes[1].valueLink && subNode.subNodes[2].name === 'Options') {
                    console.log("Processing special [3] case for subNode: ", subNode);
                    // This is a special case where we have a data link and a value link with options
                    fieldData[fieldNode.id][subNode.id] = {
                        dataLink: subNode.subNodes[0].link,
                        value: subNode.subNodes[1].name !== '<No Value>' ? subNode.subNodes[1].name : null,
                        options: {}
                    };
                    // Process the options
                    processCustomFieldConfig(subNode.subNodes[2], fieldData[fieldNode.id][subNode.id].options);
                } else */
                if (subNode.subNodes && (subNode.subNodes.length === 2 || (subNode.subNodes.length === 3 && subNode.subNodes[2].id === 'default-setting'))) {
                    // The same special cases from earlier, but now we are processing subNodes
                    if (subNode.subNodes[0].path === 'data-link' && subNode.subNodes[1].valueLink) {
                        // console.log("Processing special [2] case for subNode: ", subNode);
                        // This is a special case where we have a data link and a value link
                        fieldData[fieldNode.id][subNode.id] = {
                            dataLink: subNode.subNodes[0].link,
                            value: subNode.subNodes[1].name !== '<No Value>' ? subNode.subNodes[1].name : null
                        };
                    } else
                    if (subNode.subNodes[1].path === 'data-link' && subNode.subNodes[0].valueLink) {
                        // console.log("Processing special [2] case for subNode: ", subNode);
                        // This is a special case where we have a data link and a value link
                        fieldData[fieldNode.id][subNode.id] = {
                            dataLink: subNode.subNodes[1].link,
                            value: subNode.subNodes[0].name !== '<No Value>' ? subNode.subNodes[0].name : null
                        };
                    } else
                    if (subNode.subNodes[0].path === 'data-link' && subNode.subNodes[1].isEnum) {
                        // console.log("Processing special [2] case for subNode: ", subNode);
                        // This is a special case where we have a data link and an enum value
                        fieldData[fieldNode.id][subNode.id] = {
                            dataLink: subNode.subNodes[0].link,
                            value: subNode.subNodes[1].enumValue ?? subNode.subNodes[1].enumDefault
                        };
                    } else
                    if (subNode.subNodes[1].path === 'data-link' && subNode.subNodes[0].isEnum) {
                        // console.log("Processing special [2] case for subNode: ", subNode);
                        // This is a special case where we have a data link and an enum value
                        fieldData[fieldNode.id][subNode.id] = {
                            dataLink: subNode.subNodes[1].link,
                            value: subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault
                        };
                    }
                    if (fieldData[fieldNode.id][subNode.id] && fieldData[fieldNode.id][subNode.id].dataLink === null && subNode.subNodes[2]?.id === 'default-setting') {
                        if (subNode.subNodes[2]?.subNodes?.[0]?.booleanValue === true) {
                            fieldData[fieldNode.id][subNode.id].isDefault = true;
                        }
                    }
                } else
                if (subNode.subNodes && subNode.subNodes.length === 1) {
                    // console.log("Processing special [1] case for subNode: ", subNode);
                    if (subNode.subNodes.length === 1 && subNode.subNodes[0].valueLink) {
                        fieldData[subNode.subNodes[0].id] = subNode.subNodes[0].name !== '<No Value>' ? subNode.subNodes[0].name : null;
                    } else 
                    if (subNode.subNodes[0].isBoolean) {
                        fieldData[subNode.subNodes[0].id] = subNode.subNodes[0].booleanValue;
                    } else 
                    if (subNode.subNodes[0].isEnum) {
                        fieldData[subNode.subNodes[0].id] = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
                    } else {
                        fieldData[fieldNode.id][subNode.id] = subNode.subNodes[0].name !== '<No Value>' ? subNode.subNodes[0].name : null;
                    }
                } else {
                    // console.log("Processing complex subNode: ", subNode);
                    // Otherwise, we assume it's a complex node and we need to process it recursively
                    // fieldData[fieldNode.id][subNode.id] = {};
                    processModuleFieldConfig(subNode, fieldData[fieldNode.id]);
                }
            }
        }
    } else {
        // Is this field a data link itself, or an enum or boolean?
        if (fieldNode.linkable && fieldNode.link !== null) {
            fieldData[fieldNode.id].dataLink = fieldNode.link;
        } else if (fieldNode.isBoolean) {
            fieldData[fieldNode.id].booleanValue = fieldNode.booleanValue;
        } else if (fieldNode.isEnum) {
            fieldData[fieldNode.id].enumValue = fieldNode.enumValue ?? fieldNode.enumDefault;
        } else {
            // Otherwise, we assume it's a simple value
            fieldData[fieldNode.id].value = fieldNode.value ?? (fieldNode.name !== '<No Value>' && fieldNode.name !== '<User Editble Value>') ? fieldNode.name : null;
        }
    }
}

/* Module specific functions for processing visualisation config */
const MODULE_SPECIFIC_OUTBOUND_PROCESSORS = {
    border: (moduleNode) => {
        const borderModule = {
            name: moduleNode.name,
            type: 'module',
            module: 'border',
            fields: []
        }
        for (let i = 0; i < moduleNode.subNodes.length; i++) {
            const fieldNode = moduleNode.subNodes[i];
            // Is this a custom field?
            if (fieldNode.customisationContainerType === 'field' && fieldNode.id.includes('custom-field')) {
                    const fieldData = {
                        name: fieldNode.name,
                        type: 'field',
                    }
                    fieldData.field = 'customCustomisationField';
                    // Step through the subNodes for the custom field and extract the type and value
                    const customFieldConfig = processCustomFieldConfig(fieldNode);
                    fieldData.customFieldConfig = customFieldConfig;
                    borderModule.fields.push(fieldData);
            } else
            switch (fieldNode.id) {
                case 'customisation-module-border-color':
                    borderModule.fields.push({
                        name: fieldNode.name,
                        field: fieldNode.id,
                        type: 'field',
                        dataLink: fieldNode.subNodes[0].link,
                    });
                    break;
                case 'customisation-module-border-opacity':
                    borderModule.fields.push({
                        name: fieldNode.name,
                        field: fieldNode.id,
                        type: 'field',
                        dataLink: fieldNode.subNodes[0].link,
                    });
                    break;
                case 'customisation-module-border-position':
                    borderModule.fields.push({
                        name: fieldNode.name,
                        field: fieldNode.id,
                        type: 'field',
                        outside: {
                            dataLink: fieldNode.subNodes[0].subNodes[0].link,
                            value: fieldNode.subNodes[0].subNodes[1].name !== '<No Value>' ? (fieldNode.subNodes[0].subNodes[1].value ?? fieldNode.subNodes[0].subNodes[1].name) : null
                        },
                        inside: {
                            dataLink: fieldNode.subNodes[1].subNodes[0].link,
                            value: fieldNode.subNodes[1].subNodes[1].name !== '<No Value>' ? (fieldNode.subNodes[1].subNodes[1].value ?? fieldNode.subNodes[1].subNodes[1].name) : null
                        }
                    });
                    break;
                case 'customisation-module-border-thickness':
                    borderModule.fields.push({
                        name: fieldNode.name,
                        field: fieldNode.id,
                        type: 'field',
                        dataLink: fieldNode.subNodes[0].link,
                    });
                    break;
                default:
                    break;
            }
        }

        return borderModule;
    },
    copy: (moduleNode) => {
        const copyModule = {
            name: moduleNode.name,
            type: 'module',
            module: 'copy',
            fields: []
        }
        for (let i = 0; i < moduleNode.subNodes.length; i++) {
            const fieldNode = moduleNode.subNodes[i];
            // Is this a custom field?
            if (fieldNode.customisationContainerType === 'field' && fieldNode.id.includes('custom-field')) {
                const fieldData = {
                    name: fieldNode.name,
                    type: 'field',
                }
                fieldData.field = 'customCustomisationField';
                // Step through the subNodes for the custom field and extract the type and value
                const customFieldConfig = processCustomFieldConfig(fieldNode);
                fieldData.customFieldConfig = customFieldConfig;
                copyModule.fields.push(fieldData);
            } else
            if (fieldNode.path === 'data-link') {
                copyModule.dataLink = fieldNode.link;
            } else
            if (fieldNode.id === 'customisation-module-copy-multi-line') {
                copyModule.multiline = fieldNode.subNodes[0].name !== 'single';
            }
        }

        return copyModule;
    }
}

const processVisualisationConfigForFinalDataObject = (visualisationNode) => {
    const visualisationConfig = {
        isEnabled: null,
        direction: null,
        flex: null,
        startStep: null,
        endStep: null,
        visualisationComponent: null,
        overflow: 'hidden',
        toggle: null,
    };
    let foundVals = false;
    for (let i = 0; i < visualisationNode.subNodes.length; i++) {
        const subNode = visualisationNode.subNodes[i];
        if (subNode.id === 'is-visualisation-is-enabled') {
            visualisationConfig.isEnabled = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'visualisation-direction') {
            visualisationConfig.direction = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
            foundVals = true;
        } else if (subNode.id === 'visualisation-flex') {
            visualisationConfig.flex = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
            foundVals = true;
        } else if (subNode.id === 'start-step') {
            visualisationConfig.startStep = subNode.subNodes[0].dynamicLinkedIndex;
            foundVals = true;
        } else if (subNode.id === 'end-step') {
            visualisationConfig.endStep = subNode.subNodes[0].dynamicLinkedIndex;
            foundVals = true;
        } else if (subNode.id === 'custom-visualisation-component') {
            visualisationConfig.visualisationComponent = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
        } else if (subNode.id === 'custom-component-apply-styles') {
            visualisationConfig.applyVisualisationComponentStyles = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'visualisation-overflow') {
            visualisationConfig.overflow = subNode.subNodes[0].enumValue ?? subNode.subNodes[0].enumDefault;
            foundVals = true;
        } else if (subNode.id === 'visualisation-is-full-screen') {
            visualisationConfig.isFullScreen = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'visualisation-toggle') {
            visualisationConfig.toggle = subNode.subNodes[0].link;
            foundVals = true;
        } else if (subNode.id === 'restrict-steps') {
            visualisationConfig.restrictSteps = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'preserve-dom-space') {
            visualisationConfig.preserveDomSpace = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'reverse-visualisation-toggle') {
            visualisationConfig.reverseVisualisationToggle = subNode.subNodes[0].booleanValue;
            foundVals = true;
        } else if (subNode.id === 'advanced-visualisation-toggle') {
            visualisationConfig.advancedVisualisationToggleLink = subNode.subNodes[0].link;
            visualisationConfig.advancedVisualisationToggleValue = subNode.subNodes[1].name !== '<No Value>' ? (subNode.subNodes[1].value ?? subNode.subNodes[1].name) : null;
            visualisationConfig.advancedVisualisationToggleReverse = subNode.subNodes[2].booleanValue;
            foundVals = true;
        }
    }
    return foundVals ? visualisationConfig : null;
}

const processGroupConfigForFinalDataObject = (groupNode) => {
    const groupConfig = {
        visualise: null,
    }
    for (let i = 0; i < groupNode.subNodes.length; i++) {
        const subNode = groupNode.subNodes[i];
        if (subNode.id === 'include-in-visualisation') {
            groupConfig.visualise = subNode.subNodes[0].booleanValue;
        }
        if (subNode.id === 'group-linkage') {
            groupConfig.dataLink = subNode?.subNodes?.[0]?.link ?? null;
            const csvUploaderSubNode = subNode.subNodes.find(existingSubNode => existingSubNode.id === 'csv-uploader');
            if (csvUploaderSubNode && csvUploaderSubNode.subNodes[0].booleanValue) {
                groupConfig.csvUploader = {
                    enabled: true,
                }
                groupConfig.csvUploader.title = csvUploaderSubNode.subNodes[1].name;
                groupConfig.csvUploader.description = csvUploaderSubNode.subNodes[2].name;
                groupConfig.csvUploader.fields = [];
                const fieldsSubNode = csvUploaderSubNode.subNodes[3];
                for (let j = 0; j < fieldsSubNode.subNodes.length - 1; j++) {
                    const fieldSubNode = fieldsSubNode.subNodes[j];
                    const fieldData = {
                        name: fieldSubNode.name,
                        dataLink: fieldSubNode.subNodes[1].link,
                    }
                    groupConfig.csvUploader.fields.push(fieldData);
                }
            }
        }
        if (subNode.id === 'use-dynamic-naming') {
            groupConfig.useDynamicNaming = subNode.subNodes[0].booleanValue;
        }
        if (subNode.id === 'adjust-pos-while-dragging') {
            groupConfig.adjustPosWhileDragging = subNode.subNodes[0].booleanValue;
        }
        if (subNode.id === 'preserve-space-while-dragging') {
            groupConfig.preserveSpaceWhileDragging = subNode.subNodes[0].booleanValue;
        }
    }
    return groupConfig;
}

const addModuleSettingsToModuleData = (moduleData, moduleNode) => {
    // console.log("Adding module settings to module data: ", moduleData, moduleNode);
    const moduleConfig = {
        visualise: true,
        showInModuleList: true,
    }
    // Find the module-config node in the moduleNode's subNodes
    let configNode = null;
    for (let i = 0; i < moduleNode.subNodes.length; i++) {
        const subNode = moduleNode.subNodes[i];
        if (subNode.id === 'module-config') {
            configNode = subNode;
            break;
        }
    }
    if (configNode) {
        // Process the subNodes of the configNode
        for (let i = 0; i < configNode.subNodes.length; i++) {
            const subNode = configNode.subNodes[i];
            if (subNode.id === 'include-in-visualisation') {
                moduleConfig.visualise = subNode.subNodes[0].booleanValue;
            } else if (subNode.id === 'apply-to-content') {
                moduleConfig.applyToContent = subNode.subNodes[0].booleanValue;
            } else if (subNode.id === 'include-in-module-list') {
                moduleConfig.showInModuleList = subNode.subNodes[0].booleanValue;
            } else if (subNode.id === 'visualisation-toggle') {
                moduleConfig.visualisationToggle = subNode.subNodes[0].link;
            } else if (subNode.id === 'hide-unneeded-fields') {
                moduleConfig.hideUnneededFields = subNode.subNodes[0].booleanValue;
            } else if (subNode.id === 'reverse-visualisation-toggle') {
                moduleConfig.reverseVisualisationToggle = subNode.subNodes[0].booleanValue;
            } else if (subNode.id === 'advanced-visualisation-toggle') {
                moduleConfig.advancedVisualisationToggleLink = subNode.subNodes[0].link;
                moduleConfig.advancedVisualisationToggleValue = subNode.subNodes[1].name !== '<No Value>' ? (subNode.subNodes[1].value ?? subNode.subNodes[1].name) : null;
                moduleConfig.advancedVisualisationToggleReverse = subNode.subNodes[2].booleanValue;
            }
        }
    }
    moduleData.moduleSettings = moduleConfig;
}

/**
 * Since our node list data is saved to local storage as it is, we need to update it when loaded in to ensure it has any new functionality that has been added.
 */
// Don't replace these properties as they are our core properties that we need to keep
const PRESERVE_PROPERTIES = [
    'id', 
    'name', 
    'instanceId', 
    'instanceName', 
    'path', 
    'expanded',     
    'customisationContainerType',
    'hasChildren',
    'expanded',
    'depth',
    'selected',
    'link',
    'enumValue',
    'booleanValue',
    'fixedValue',
    'isShown',
    'valueLink',
    'dynamicLinkedIndex',
    'subNodes',
];
const DUMMY_INITIAL_DATA = {};
export const updateNodeListData = (nodeListData, subNodesToCompareTo = null) => {
    // console.log("--- Updating nodeListData: ", nodeListData, subNodesToCompareTo);
    if (typeof DUMMY_INITIAL_DATA.dummyData === 'undefined') {
        // If the dummy data is not set, set it to an empty object
        DUMMY_INITIAL_DATA.dummyData = getInitialNewFormatData('dummy-feature-id', 'Dummy Feature', 'dummy-instance-id', 'Dummy Instance');
    }
    if (subNodesToCompareTo && Array.isArray(subNodesToCompareTo)) {
        // If we have a subNode with removeFromNestedGroups === false and an equivilent subNode doesn't exist in the nodeListData, we need to add it
        for (const subNode of subNodesToCompareTo) {
            if (typeof subNode.removeFromNestedGroups !== 'undefined' && subNode.removeFromNestedGroups === false) {
                const existingNode = nodeListData.find(node => node.id === subNode.id);
                if (!existingNode) {
                    console.log("--- Updating nodeListData >>> Add missing visualisation subNode: ", subNode.id);
                    const subNodeToAdd = JSON.parse(JSON.stringify(subNode)); // Deep copy the subNode to avoid mutating the original
                    nodeListData.push(subNodeToAdd);
                    if (subNodeToAdd.subNodes && Array.isArray(subNodeToAdd.subNodes)) {
                        if (subNodeToAdd.subNodes[0].id === 'visualisation-is-enabled-value') {
                            subNodeToAdd.subNodes[0].booleanValue = true;
                            subNodeToAdd.subNodes[0].name = 'True';
                        }
                    }
                }
            }
        }
        
        // Now any subNodes which don't include "visualisation" in their id, need adding to the nodeListData if there isn't an existing node with the same id
        // But only if they are not visualisation nodes or don't have a removeFromNestedGroups property
        for (const subNode of subNodesToCompareTo) {
            if (!subNode.id.includes('visualisation') /* && typeof subNode.removeFromNestedGroups === 'undefined' */) {
                const existingNode = nodeListData.find(node => node.id === subNode.id);
                if (!existingNode) {
                    console.log("--- Updating nodeListData >>> Add missing subNode: ", subNode.id);
                    const subNodeToAdd = JSON.parse(JSON.stringify(subNode)); // Deep copy the subNode to avoid mutating the original
                    nodeListData.push(subNodeToAdd);
                }
            }
        }

        // If we have a subNode with removeFromNestedGroups === true, we need to remove it from the nodeListData, but only if the depth is >= 5
        for (const subNode of subNodesToCompareTo) {
            if (subNode.removeFromNestedGroups === true) {
                const existingNodeIndex = nodeListData.findIndex(node => node.id === subNode.id);
                const existingNode = nodeListData[existingNodeIndex];
                if (existingNodeIndex !== -1 && existingNode.depth >= 5) {
                    console.log("--- Updating nodeListData >>> Remove visualisation subNode: ", subNode.id);
                    nodeListData.splice(existingNodeIndex, 1);
                }
            }
            /* if (subNode.onlyInNestedGroups === true) {
                const existingNodeIndex = nodeListData.findIndex(node => node.id === subNode.id);
                const existingNode = nodeListData[existingNodeIndex];
                if (existingNodeIndex !== -1 && existingNode.depth < 5) {
                    console.log("--- Updating nodeListData >>> Remove visualisation subNode: ", subNode.id);
                    nodeListData.splice(existingNodeIndex, 1);
                }
            } */
        }
    }
    
    // Update the nodeListData as needed
    for (let i = 0; i < nodeListData.length; i++) {
        console.log("--- Updating nodeListData for node: ", nodeListData[i].id);
        const nodeData = nodeListData[i];
        nodeData.selected = false;
        nodeData.active = false;
        // If this is the visualisation node and it's depth is 3, we need to add in any missing properties
        if (nodeData.id.includes('customisation-group-visualisation-settings') && nodeData.depth === 3) {
            // Add any missing properties here
            const visualisationStructure = BLANK_STRUCTURES.customisationGroup.subNodes[0];
            for (let i = 0; i < visualisationStructure.subNodes.length; i++) {
                const subNode = visualisationStructure.subNodes[i];
                if (!nodeData.subNodes.some(existingSubNode => existingSubNode.id === subNode.id)) {
                    console.log("--- Updating nodeListData >>> Add missing visualisation subNode: ", subNode.id);
                    const newSubNode = JSON.parse(JSON.stringify(subNode)); // Deep copy the subNode to avoid mutating the original
                    nodeData.subNodes.push(newSubNode);
                }
            }
        } else
        if (nodeData.depth === 0) {
            nodeData.renamable = true;
            updateNodeListData(nodeData.subNodes);
        } else
        if (nodeData.depth === 1) {
            // Find the correspanding subNode in the dummy data
            for (let i = 0; i < DUMMY_INITIAL_DATA.dummyData.subNodes.length; i++) {
                const dummySubNode = DUMMY_INITIAL_DATA.dummyData.subNodes[i];
                if (dummySubNode.id === nodeData.id) {
                    // Compare and update the node data with the dummy data
                    compareAndUpdateNodeListObjects(nodeData, dummySubNode);
                    break;
                }
            }
        } else
        if (nodeData.customisationContainerType === 'field' && nodeData.id.includes('customisation-custom-field')) {
            // Make sure the sub nodes for custom fields have everything we need...
            const customFieldData = BLANK_STRUCTURES.customCustomisationField;
            for (let i = 0; i < customFieldData.subNodes.length; i++) {
                const subNode = customFieldData.subNodes[i];
                if (!nodeData.subNodes.some(existingSubNode => existingSubNode.id === subNode.id)) {
                    console.log("--- Updating nodeListData >>> Add missing custom field subNode: ", subNode.id);
                    const newSubNode = JSON.parse(JSON.stringify(subNode)); // Deep copy the subNode to avoid mutating the original
                    nodeData.subNodes.push(newSubNode);
                }
            }
        } else {
            // The fun bit!
            // If this is a group or module we need to find the matching group or module in BLANK_STRUCTURES or CUSTOMISATION_MODULES
            if (nodeData.customisationContainerType === 'group') {
                compareAndUpdateNodeListObjects(nodeData, BLANK_STRUCTURES.customisationGroup);
            } else if (nodeData.customisationContainerType === 'module') {
                // Find the module type, the start of the id should match an id in CUSTOMISATION_MODULES
                for (const key in CUSTOMISATION_MODULES) {
                    if (nodeData.id.startsWith(CUSTOMISATION_MODULES[key].id)) {
                        compareAndUpdateNodeListObjects(nodeData, CUSTOMISATION_MODULES[key]);
                        break;
                    }
                }
            } else {
                // If we have subNodes to compare to, look for an object with a matching id
                if (subNodesToCompareTo && Array.isArray(subNodesToCompareTo)) {
                    for (const subNode of subNodesToCompareTo) {
                        const isUniqueName = !isNaN(parseInt(nodeData.id.split('-').pop())); // Check if the last part of the id is a number
                        if ((isUniqueName && nodeData.id.startsWith(subNode.id)) || (!isUniqueName && nodeData.id === subNode.id)) {
                            compareAndUpdateNodeListObjects(nodeData, subNode);
                            break;
                        }
                    }
                }
            }
        }
    }
}
const compareAndUpdateNodeListObjects = (nodeData, nodeConfigData) => {
    let objectUpdated = false;
    // First add in properties that are in the config data but not in the node data
    for (const key in nodeConfigData) {
        if (!nodeData.hasOwnProperty(key)) {
            // If the key is not in the node data, add it
            console.log("--- Updating nodeListData >>> Add missing key: ", key);
            nodeData[key] = nodeConfigData[key];
            objectUpdated = true;
        }
    }
    // If this is a group, make sure we have a group config in our subNodes
    if (nodeData.customisationContainerType === 'group') {
        if (!nodeData.subNodes.some(subNode => subNode.id === 'group-config')) {
            console.log("--- Updating nodeListData >>> Add missing group config subNode");
            const groupConfigSubNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.groupConfig));
            // nodeData.subNodes.push(groupConfigSubNode);
            // Add the new subnode to the start of the subNodes array
            nodeData.subNodes.unshift(groupConfigSubNode);
            objectUpdated = true;
        } else {
            // This is a group with a group config
            // Make sure group config is up to date by adding any missing properties
            const groupConfigSubNode = nodeData.subNodes.find(subNode => subNode.id === 'group-config');
            if (groupConfigSubNode) {
                const groupConfigData = BLANK_STRUCTURES.groupConfig;
                // Add any missing subNodes to the group config
                for (let i = 0; i < groupConfigData.subNodes.length; i++) {
                    const subNode = groupConfigData.subNodes[i];
                    if (!groupConfigSubNode.subNodes.some(existingSubNode => existingSubNode.id === subNode.id)) {
                        console.log("--- Updating nodeListData >>> Add missing group config subNode: ", subNode.id);
                        groupConfigSubNode.subNodes.push(JSON.parse(JSON.stringify(subNode)));
                        objectUpdated = true;
                    }
                    // Find the group linkage subNode and make sure it has the correct properties (we now have csv uploader in here)
                    if (subNode.id === 'group-linkage') {
                        let groupLinkageSubNode = groupConfigSubNode.subNodes.find(existingSubNode => existingSubNode.id === 'group-linkage');
                        if (!groupLinkageSubNode) {
                            console.log("--- Updating nodeListData >>> Add missing group linkage subNode");
                            groupLinkageSubNode = JSON.parse(JSON.stringify(subNode));
                            groupConfigSubNode.subNodes.push(groupLinkageSubNode);
                            objectUpdated = true;
                        } else {
                            // Make sure the group linkage subnode has the new csv uploader properties
                            if (!groupLinkageSubNode.subNodes.some(existingSubNode => existingSubNode.id === 'csv-uploader')) {
                                console.log("--- Updating nodeListData >>> Add missing group linkage csv uploader subNode");
                                const csvUploaderSubNode = BLANK_STRUCTURES.groupConfig.subNodes.find(subNode => subNode.id === 'group-linkage').subNodes.find(subNode => subNode.id === 'csv-uploader');
                                groupLinkageSubNode.subNodes.push(JSON.parse(JSON.stringify(csvUploaderSubNode)));
                                objectUpdated = true;
                            } else {
                                // We have the csv uploader subnode, but does it have the correct properties?
                                const csvUploaderSubNode = groupLinkageSubNode.subNodes.find(existingSubNode => existingSubNode.id === 'csv-uploader');
                                const defaultCsvUploaderSubNode = BLANK_STRUCTURES.groupConfig.subNodes.find(subNode => subNode.id === 'group-linkage').subNodes.find(subNode => subNode.id === 'csv-uploader');
                                for (const key in defaultCsvUploaderSubNode) {
                                    if (!csvUploaderSubNode.hasOwnProperty(key)) {
                                        console.log("--- Updating nodeListData >>> Add missing property to group linkage csv uploader subNode: ", key);
                                        csvUploaderSubNode[key] = JSON.parse(JSON.stringify(defaultCsvUploaderSubNode[key]));
                                        objectUpdated = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    // If this is a module, make sure we have a module config in our subNodes
    if (nodeData.customisationContainerType === 'module') {
        if (!nodeData.subNodes.some(subNode => subNode.id === 'module-config')) {
            console.log("--- Updating nodeListData >>> Add missing module config subNode");
            const moduleConfigSubNode = JSON.parse(JSON.stringify(BLANK_STRUCTURES.moduleConfig));
            // nodeData.subNodes.push(moduleConfigSubNode);
            // Add the new subnode to the start of the subNodes array
            nodeData.subNodes.unshift(moduleConfigSubNode);
        } else {
            // Let's make sure our module config has all the sub nodes needed
            const moduleConfigSubNode = nodeData.subNodes.find(subNode => subNode.id === 'module-config');
            const defaultModuleConfig = BLANK_STRUCTURES.moduleConfig;
            if (moduleConfigSubNode) {
                for (let i = 0; i < defaultModuleConfig.subNodes.length; i++) {
                    const subNode = defaultModuleConfig.subNodes[i];
                    if (!moduleConfigSubNode.subNodes.some(existingSubNode => existingSubNode.id === subNode.id)) {
                        console.log("--- Updating nodeListData >>> Add missing module config subNode: ", subNode.id);
                        moduleConfigSubNode.subNodes.push(JSON.parse(JSON.stringify(subNode)));
                    }
                }
            }
        }
    }

    // Now update any values that are in the node data but also in the config data, but not in the preserve list
    // This will ensure that we don't overwrite any properties that we want to keep
    for (const key in nodeData) {
        if (key === 'subNodes' && Array.isArray(nodeData.subNodes) && Array.isArray(nodeConfigData.subNodes)) {
            updateNodeListData(nodeData.subNodes, nodeConfigData.subNodes);
        } else if (nodeConfigData.hasOwnProperty(key) && !PRESERVE_PROPERTIES.includes(key)) {
            // If the key is in the config data and not in the preserve list, update it
            if (nodeData[key] === nodeConfigData[key]) {
                // If the values are the same, we don't need to update
                continue;
            }
            console.log("--- Updating nodeListData >>> Update key value: ", key, nodeData[key], " to ", nodeConfigData[key]);
            nodeData[key] = nodeConfigData[key];
            objectUpdated = true;
        } else if (typeof nodeData[key] === 'object' && nodeData[key] !== null && nodeConfigData.hasOwnProperty(key) && typeof nodeConfigData[key] === 'object' && nodeConfigData[key] !== null) {
            // If the value is an object, recursively compare and update
            compareAndUpdateNodeListObjects(nodeData[key], nodeConfigData[key]);
        }
    }
    // If the object was updated, we need to set the selected property to false
    if (objectUpdated) {
        console.log("--- Updating nodeListData >>> Updated nodeData: ", nodeData);
    }
}

export const getInitialNewFormatData = (featureId, featureName, instanceId, instanceName) => {
    console.log("Get initial new format data for featureId: ", featureId);
    const initialNewFormatData = {
        id: featureId,
        name: featureName,
        instanceId: instanceId,
        instanceName: instanceName,
        path: featureId,
        hasChildren: true,
        enabled: true,
        expanded: true,
        renamable: true,
        subNodes: [
            {
                id: 'timeline',
                name: 'Timeline',
                path: 'timeline',
                hasChildren: true,
                enabled: true,
                renamable: true,
                subNodes: [
                    {
                        id: 'timeline-steps',
                        name: 'Steps',
                        path: 'timeline.steps',
                        hasChildren: true,
                        enabled: true,
                        renamable: true,
                        subNodes: [
                            {
                                id: 'timeline-steps-start',
                                name: 'Start',
                                path: 'timeline.steps.start',
                                enabled: true,
                                clickable: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [],
                                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                            },
                            {
                                id: 'timeline-steps-main',
                                name: 'Main',
                                path: 'timeline.steps.main',
                                enabled: true,
                                clickable: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [],
                                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                            },
                            {
                                id: 'timeline-steps-end',
                                name: 'End',
                                path: 'timeline.steps.end',
                                enabled: true,
                                clickable: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [],
                                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                            },
                            {
                                id: 'timeline-steps-add',
                                name: 'Add Step',
                                isAddButton: true,
                                path: featureId + '.timeline.steps-add',
                                enabled: true,
                                clickAction: "add-timeline-step",
                                alwaysAtBottom: true,
                            }
                        ],
                    },
                    {
                        id: 'timeline-audio',
                        name: 'Audio Groups',
                        path: '.timeline.audio',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'timeline-audio-ambience',
                                name: 'Ambience',
                                path: 'timeline.audio.ambience',
                                hasChildren: true,
                                enabled: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [
                                    {
                                        id: 'timeline-audio-add',
                                        name: 'Add Audio',
                                        isAddButton: true,
                                        path: 'timeline.audio.add',
                                        enabled: true,
                                        alwaysAtBottom: true,
                                        clickAction: "add-timeline-audio",
                                    }
                                ],
                            },
                            {
                                id: 'timeline-audio-sfx',
                                name: 'SFX',
                                path: 'timeline.audio.sfx',
                                hasChildren: true,
                                enabled: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [
                                    {
                                        id: 'timeline-audio-add',
                                        name: 'Add Audio',
                                        isAddButton: true,
                                        path: 'timeline.audio.add',
                                        enabled: true,
                                        alwaysAtBottom: true,
                                        clickAction: "add-timeline-audio",
                                    }
                                ],
                            },
                            {
                                id: 'timeline-audio-group-add',
                                name: 'Add Audio Group',
                                isAddButton: true,
                                path: 'timeline.audio.group-add',
                                enabled: true,
                                alwaysAtBottom: true,
                                clickAction: "add-timeline-audio-group",
                            }
                        ],
                    },
                    {
                        id: 'timeline-disruptors',
                        name: 'Disruptor Groups',
                        path: 'timeline.disruptors',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'timeline-disruptors-group1',
                                name: 'Disruptors',
                                path: 'timeline.disruptors.group1',
                                hasChildren: true,
                                enabled: true,
                                renamable: true,
                                draggable: true,
                                removable: true,
                                subNodes: [
                                    {
                                        id: 'timeline-disruptors-add',
                                        name: 'Add Disruptor',
                                        isAddButton: true,
                                        path: 'timeline.disruptors.add',
                                        enabled: true,
                                        alwaysAtBottom: true,
                                        clickAction: "add-timeline-disruptor",
                                    }
                                ],
                            },
                            {
                                id: 'timeline-disruptors-group-add',
                                name: 'Add Disruptor Group',
                                isAddButton: true,
                                path: 'timeline.disruptors.group-add',
                                enabled: true,
                                alwaysAtBottom: true,
                                clickAction: "add-timeline-disruptor-group",
                            }
                        ],
                    }
                ],
            },
            {
                id: 'customisation',
                name: 'Customisation',
                path: 'customisation',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-group-add',
                        name: 'Add Group',
                        path: 'customisation.group.add',
                        isAddButton: true,
                        enabled: true,
                        alwaysAtBottom: true,
                        clickAction: "add-customisation-group",
                    }
                ],
            }
        ],
    };
    console.log("Initial new format data: ", initialNewFormatData);
    return initialNewFormatData;
}

export const BLANK_STRUCTURES = {
    groupConfig: {
        id: 'group-config',
        name: 'Group Config',
        path: 'group-config',
        hasChildren: true,
        enabled: true,
        renamable: false,
        draggable: false,
        removable: false,
        alwaysAtTop: true, // This node should always be at the top of the group
        subNodes: [
            {
                id: 'include-in-visualisation',
                name: 'Include in Visualisation',
                path: 'include-in-visualisation',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'include-in-visualisation-value',
                        name: 'True',
                        path: 'include-in-visualisation.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'group-linkage',
                name: 'Group Linkage',
                path: 'group-linkage',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'group-linkage-data-link',
                        name: '<Not Linked>',
                        path: 'data-link', 
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    },
                    {
                        id: 'csv-uploader',
                        name: 'CSV Uploader',
                        path: 'csv-uploader',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'enable-csv-uploader-value',
                                name: 'False',
                                path: 'enable-csv-uploader.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            },
                            {
                                id: 'csv-uploader-title',
                                name: 'CSV Uploader Title',
                                path: 'csv-uploader-title',
                                enabled: true,
                                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                                renamable: true,
                            },
                            {
                                id: 'csv-uploader-description',
                                name: 'CSV Uploader Description',
                                path: 'csv-uploader-description',
                                enabled: true,
                                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                                renamable: true,
                            },
                            {
                                id: 'csv-uploader-fields',
                                name: 'CSV Uploader Fields',
                                path: 'csv-uploader-fields',
                                hasChildren: true,
                                enabled: true,
                                subNodes: [
                                    {
                                        id: 'add-csv-uploader-field',
                                        name: 'Add Field',
                                        path: 'add-csv-uploader-field',
                                        enabled: true,
                                        alwaysAtBottom: true,
                                        clickAction: "add-csv-uploader-field",
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            {
                id: 'use-dynamic-naming',
                name: 'Use Dynamic Naming',
                path: 'use-dynamic-naming',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'use-dynamic-naming-value',
                        name: 'True',
                        path: 'use-dynamic-naming.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'adjust-pos-while-dragging',
                name: 'Dragging Affects Pos?',
                path: 'adjust-pos-while-dragging',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'adjust-pos-while-dragging-value',
                        name: 'True',
                        path: 'adjust-pos-while-dragging.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'preserve-space-while-dragging',
                name: 'Preserve Space While Dragging?',
                path: 'preserve-space-while-dragging',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'preserve-space-while-dragging-value',
                        name: 'False',
                        path: 'preserve-space-while-dragging.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
        ],
    },
    moduleConfig: {
        id: 'module-config',
        name: 'Module Config',
        path: 'module-config',
        hasChildren: true,
        enabled: true,
        renamable: false,
        draggable: false,
        removable: false,
        alwaysAtTop: true, // This node should always be at the top of the module
        subNodes: [
            {
                id: 'include-in-visualisation',
                name: 'Include in Visualisation',
                path: 'include-in-visualisation',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'include-in-visualisation-value',
                        name: 'True',
                        path: 'include-in-visualisation.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'apply-to-content',
                name: 'Apply to Content',
                path: 'apply-to-content',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'apply-to-content-value',
                        name: 'False',
                        path: 'apply-to-content.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'visualisation-toggle',
                name: 'Visualisation Toggle',
                path: 'visualisation-toggle',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'visualisation-toggle',
                        name: '<Not Linked>',
                        path: 'visualisation-toggle.data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        subNodes: [],
                    }
                ]
            },
            {
                id: 'reverse-visualisation-toggle',
                name: 'Reverse Visualisation Toggle',
                path: 'reverse-visualisation-toggle',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'reverse-visualisation-toggle-value',
                        name: 'False',
                        path: 'reverse-visualisation-toggle.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'advanced-visualisation-toggle',
                name: 'Advanced Visualisation Toggle',
                path: 'advanced-visualisation-toggle',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'advanced-visualisation-toggle-data-link',
                        name: '<Not Linked>',
                        path: 'advanced-visualisation-toggle.data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        subNodes: [],
                    },
                    {
                        id: 'advanced-visualisation-toggle-value',
                        name: '<No Value>',
                        path: 'advanced-visualisation-toggle.value',
                        enabled: true,
                        renamable: true,
                        valueLink: true,
                        linkable: false, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        subNodes: [],
                    },
                    {
                        id: 'reverse-advanced-visualisation-toggle-value',
                        name: 'False',
                        path: 'reverse-advanced-visualisation-toggle.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'include-in-module-list',
                name: 'Include in Module List',
                path: 'include-in-module-list',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'include-in-module-list-value',
                        name: 'True',
                        path: 'include-in-module-list.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'hide-unneeded-fields',
                name: 'Hide Unneeded Fields',
                path: 'hide-unneeded-fields',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'hide-unneeded-fields-value',
                        name: 'False',
                        path: 'hide-unneeded-fields.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            }
        ],
    },
    step:  {
        id: 'timeline-steps-newstep',
        name: 'New Step',
        path: 'timeline.steps.newstep',
        enabled: true,
        clickable: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [],
        defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
    },
    audioGroup: {
        id: 'timeline-audio-newaudiogroup',
        name: 'New Audio Group',
        path: 'timeline.audio.newaudiogroup',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'timeline-audio-add',
                name: 'Add Audio',
                isAddButton: true,
                path: 'timeline.audio.add',
                enabled: true,
                alwaysAtBottom: true,
                clickAction: "add-timeline-audio",
            }
        ],
    },
    timelineAudio: {
        id: 'newaudio',
        name: 'New Audio',
        path: 'newaudio',
        module: 'audio',
        hasChildren: true,
        enabled: true,
        draggable: true,
        renamable: true,
        removable: true,
        subNodes: [
            {
                id: 'audio-enabled',
                name: 'Enabled',
                path: 'audio-enabled',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'enabled-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'audio-name',
                name: 'Name',
                path: 'audio-name',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'name-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'audio-file',
                name: 'Audio File',
                path: 'audio-file',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'audio-file-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'audio-loop',
                name: 'Loop',
                path: 'audio-loop',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'loop-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'audio-volume',
                name: 'Volume',
                path: 'audio-volume',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'vol-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'audio-delay',
                name: 'Delay',
                path: 'audio-delay',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'delay-data-link',
                        name: '<Not Linked>',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'trigger-step',
                name: 'Trigger Step',
                path: 'trigger-step',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'trigger-step-link',
                        name: '<Not Linked>',
                        dynamicLinkedIndex: 0,
                        dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                        enabled: true,
                        stepChoice: true,
                        defaultToRightClickMenu: true,
                    }
                ]
            },
            {
                id: 'end-step',
                name: 'End Step',
                path: 'end-step',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'trigger-step-link',
                        name: '<Not Linked>',
                        dynamicLinkedIndex: 0,
                        dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                        enabled: true,
                        stepChoice: true,
                        defaultToRightClickMenu: true,
                    }
                ]
            },
        ]
    },
    disruptorGroup: {
        id: 'timeline-disruptors-newdisruptorgroup',
        name: 'New Disruptor Group',
        path: 'timeline.disruptors.newdisruptorgroup',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'timeline-disruptors-add',
                name: 'Add Disruptor',
                isAddButton: true,
                path: 'timeline.disruptors.add',
                enabled: true,
                alwaysAtBottom: true,
                clickAction: "add-timeline-disruptor",
            }
        ],
    },
    timelineDisruptor: {
        id: 'newdisruptor',
        name: 'New Disruptor',
        path: 'newdisruptor',
        module: 'disruptor',
        hasChildren: true,
        enabled: true,
        draggable: true,
        renamable: true,
        removable: true,
        subNodes: [
            {
                id: 'disruptor-enabled',
                name: 'Enabled',
                path: 'disruptor-enabled',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'enabled-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'disruptor-select',
                name: 'Select Disruptor',
                path: 'disruptor-select',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'select-disruptor-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'disruptor-wait-for-end',
                name: 'Wait for End',
                path: 'disruptor-wait-for-end',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'wait-for-end-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            },
            {
                id: 'trigger-step',
                name: 'Trigger Step',
                path: 'trigger-step',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'trigger-step-link',
                        name: '<Not Linked>',
                        dynamicLinkedIndex: 0,
                        dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                        enabled: true,
                        stepChoice: true,
                        defaultToRightClickMenu: true,
                    }
                ]
            },
            {
                id: 'end-step',
                name: 'End Step',
                path: 'end-step',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'trigger-step-link',
                        name: '<Not Linked>',
                        dynamicLinkedIndex: 0,
                        dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                        enabled: true,
                        stepChoice: true,
                        defaultToRightClickMenu: true,
                    }
                ]
            },
        ]
    },
    customisationGroup: {
        id: 'new-customisation-group',
        name: 'New Group',
        path: 'new-component',
        customisationContainerType: 'group',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-group-visualisation-settings',
                name: 'Visualisation Settings',
                path: 'customisation.group.visualisation-settings',
                hasChildren: true,
                enabled: true,
                alwaysAtTop: true, // This group will always be at the top of the customisation group
                subNodes: [
                    {
                        id: 'is-visualisation-is-enabled',
                        name: 'Visualisation Enabled',
                        path: 'customisation.group.visualisation-settings.is-enabled',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: true, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'visualisation-is-enabled-value',
                                name: 'False',
                                path: 'customisation.group.visualisation-settings.is-enabled.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'visualisation-toggle',
                        name: 'Visualisation Toggle',
                        path: 'customisation.group.visualisation-settings.visualisation-toggle',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'visualisation-toggle',
                                name: '<Not Linked>',
                                path: 'visualisation-toggle.data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                subNodes: [],
                            }
                        ]
                    },
                    {
                        id: 'reverse-visualisation-toggle',
                        name: 'Reverse Visualisation Toggle',
                        path: 'customisation.group.visualisation-settings.reverse-visualisation-toggle',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'reverse-visualisation-toggle-value',
                                name: 'False',
                                path: 'reverse-visualisation-toggle.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'advanced-visualisation-toggle',
                        name: 'Advanced Visualisation Toggle',
                        path: 'advanced-visualisation-toggle',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'advanced-visualisation-toggle-data-link',
                                name: '<Not Linked>',
                                path: 'advanced-visualisation-toggle.data-link',
                                enabled: true,
                                removeFromNestedGroups: false, // This node can be removed from nested groups
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                subNodes: [],
                            },
                            {
                                id: 'advanced-visualisation-toggle-value',
                                name: '<No Value>',
                                path: 'advanced-visualisation-toggle.value',
                                enabled: true,
                                removeFromNestedGroups: false, // This node can be removed from nested groups
                                renamable: true,
                                valueLink: true,
                                linkable: false, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                subNodes: [],
                            },
                            {
                                id: 'reverse-advanced-visualisation-toggle-value',
                                name: 'False',
                                path: 'reverse-advanced-visualisation-toggle.value',
                                enabled: true,
                                removeFromNestedGroups: false, // This node can be removed from nested groups
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'visualisation-direction',
                        name: 'Visualisation Direction',
                        path: 'customisation.group.visualisation-settings.direction',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'visualisation-direction-value',
                                name: 'Left to Right',
                                path: 'customisation.group.visualisation-settings.direction.value',
                                enabled: true,
                                isEnum: true, // This node is an enum value
                                enumValues: ['Left to Right', 'Top to Bottom'], // Possible values for the enum
                                enumValue: 'Left to Right', // Initial value
                                defaultToRightClickMenu: true, // This node can be changed from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'visualisation-flex',
                        name: 'Visualisation Flex',
                        path: 'customisation.group.visualisation-settings.flex',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'visualisation-flex-value',
                                name: 'Auto',
                                path: 'customisation.group.visualisation-settings.flex.value',
                                enabled: true,
                                isEnum: true, // This node is an enum value
                                enumValues: ['Auto', 'Grow', 'Shrink', 'None'], // Possible values for the enum
                                enumValue: 'Auto', // Initial value
                                defaultToRightClickMenu: true, // This node can be changed from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'restrict-steps',
                        name: 'Restrict Steps',
                        path: 'customisation.group.visualisation-settings.restrict-steps',
                        hasChildren: true,
                        enabled: true,
                        // onlyInNestedGroups: true, // This node only exists in nested groups
                        subNodes: [
                            {
                                id: 'restrict-steps-value',
                                name: 'False',
                                path: 'customisation.group.visualisation-settings.restrict-steps.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'preserve-dom-space',
                        name: 'Keep DOM Space',
                        path: 'customisation.group.visualisation-settings.preserve-dom-space',
                        hasChildren: true,
                        enabled: true,
                        // onlyInNestedGroups: true, // This node only exists in nested groups
                        subNodes: [
                            {
                                id: 'preserve-dom-space-value',
                                name: 'False',
                                path: 'customisation.group.visualisation-settings.preserve-dom-space.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'start-step',
                        name: 'Start Step',
                        path: 'start-step',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'trigger-step-link',
                                name: '<Not Linked>',
                                dynamicLinkedIndex: 0,
                                dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                                enabled: true,
                                stepChoice: true,
                                defaultToRightClickMenu: true,
                            }
                        ]
                    },
                    {
                        id: 'end-step',
                        name: 'End Step',
                        path: 'end-step',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'trigger-step-link',
                                name: '<Not Linked>',
                                dynamicLinkedIndex: 0,
                                dynamicName: {id: 'timeline-steps', path: 'timeline.steps'},
                                enabled: true,
                                stepChoice: true,
                                defaultToRightClickMenu: true,
                            }
                        ]
                    },
                    {
                        id: 'custom-visualisation-component',
                        name: 'Visualisation Component',
                        path: 'custom-visualisation-component',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'select-component',
                                name: '<Standard>',
                                enabled: true,
                                isEnum: true,
                                enumValues: 'visualisationComponents',
                                enumValue: '<Standard>', // Initial value
                                enumDefault: '<Standard>', // Default value to reset to
                                defaultToRightClickMenu: true,
                            },
                        ],
                    },
                    {
                        id: 'custom-component-apply-styles',
                        name: 'Always Apply Styles',
                        path: 'customisation.group.visualisation-settings.custom-component-apply-styles',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'custom-component-apply-styles',
                                name: 'False',
                                path: 'customisation.group.visualisation-settings.custom-component-apply-styles.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                    {
                        id: 'visualisation-overflow',
                        name: 'Visualisation Overflow',
                        path: 'visualisation-overflow',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: false, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'select-overflow',
                                name: 'hidden',
                                enabled: true,
                                isEnum: true,
                                enumValues: ['hidden', 'visible'], // Possible values for the enum
                                enumValue: 'hidden', // Initial value
                                enumDefault: 'hidden', // Default value to reset to
                                defaultToRightClickMenu: true,
                            }
                        ]
                    },
                    {
                        id: 'visualisation-is-full-screen',
                        name: 'Visualisation Full Screen',
                        path: 'customisation.group.visualisation-settings.is-full-screen',
                        hasChildren: true,
                        enabled: true,
                        removeFromNestedGroups: true, // This node can be removed from nested groups
                        subNodes: [
                            {
                                id: 'visualisation-is-full-screen-value',
                                name: 'False',
                                path: 'customisation.group.visualisation-settings.is-full-screen.value',
                                enabled: true,
                                isBoolean: true, // This node is a boolean value
                                booleanValue: false, // Initial value
                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                            }
                        ]
                    },
                ]
            },
            {
                id: 'customisation-module-add',
                name: 'Add Customisation Module',
                isAddButton: true,
                path: 'customisation.module.add',
                enabled: true,
                alwaysAtBottom: true,
                clickAction: "add-customisation-module",
                defaultToRightClickMenu: true,
            },
            {
                id: 'customisation-group-add',
                name: 'Add Group',
                path: 'customisation.group.add',
                isAddButton: true,
                enabled: true,
                alwaysAtBottom: true,
                clickAction: "add-customisation-group",
            }
        ],
    },
    customCustomisationField: {
        id: 'customisation-custom-field',
        name: 'New Customisation Field',    // Will be replaced with the type
        path: 'customisation.custom-field',
        customisationContainerType: 'field',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-custom-field-description',
                name: '[Custom Field]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-custom-field-type',
                name: 'Type',
                path: 'customisation.custom-field.type',
                enabled: true,
                subNodes: [],
                clickAction: "change-customisation-field-type",
                defaultToRightClickMenu: true,
            },
            {
                id: 'customisation-custom-field-name-content',
                name: '<Use Default Label>',
                defaultName: '<Use Default Label>', // Placeholder for default name, any node with a defaultName prop can be reset to this value from the right-click menu
                path: 'customisation.custom-field.name.content',
                enabled: true,
                renamable: true,
                defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                subNodes: [],
            },
            {
                id: 'customisation-custom-field-name-data-link',
                name: '<Not Linked>',
                path: 'customisation.custom-field.name.data-link',
                enabled: true,
                linkable: true, // This node can be linked to a legacy data node path
                link: null,     // Initially no link
                subNodes: [],
            },
            {
                id: 'customisation-custom-field-fix-value',
                name: 'Fixed Value?',
                path: 'customisation.custom-field.fix-value',
                hasChildren: true,
                enabled: true,
                subNodes: [
                     {
                        id: 'customisation-custom-field-fix-value-value',
                        name: '<User Editable Value>',
                        path: 'customisation.custom-field.fix-value.value',
                        enabled: true,
                        renamable: true,
                        subNodes: [],
                        defaultName: '<User Editable Value>', // Placeholder for default value, any node with a defaultName prop can be reset to this value from the right-click menu
                        defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                    },
                ],
            },
           
            {
                id: 'customisation-custom-field-shown',
                name: 'Shown?',
                path: 'customisation.custom-field.shown',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-custom-field-shown-value',
                        name: 'True',
                        path: 'customisation.custom-field.shown.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: true, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },
            {
                id: 'customisation-custom-field-wide',
                name: 'Wide?',
                path: 'customisation.custom-field.wide',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-custom-field-wide-value',
                        name: 'False',
                        path: 'customisation.custom-field.wide.value',
                        enabled: true,
                        isBoolean: true, // This node is a boolean value
                        booleanValue: false, // Initial value
                        defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                    }
                ]
            },

            {
                id: 'customisation-custom-field-on-value',
                name: 'On Value (bools)?',
                path: 'customisation.custom-field.on-value',
                hasChildren: true,
                enabled: true,
                subNodes: [
                     {
                        id: 'customisation-custom-field-on-value-value',
                        name: '<Default Value>',
                        path: 'customisation.custom-field.on-value.value',
                        enabled: true,
                        renamable: true,
                        subNodes: [],
                        defaultName: '<Default Value>', // Placeholder for default value, any node with a defaultName prop can be reset to this value from the right-click menu
                        defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                    },
                ],
            },
            {
                id: 'customisation-custom-field-off-value',
                name: 'Off Value (bools)?',
                path: 'customisation.custom-field.off-value',
                hasChildren: true,
                enabled: true,
                subNodes: [
                     {
                        id: 'customisation-custom-field-off-value-value',
                        name: '<Default Value>',
                        path: 'customisation.custom-field.off-value.value',
                        enabled: true,
                        renamable: true,
                        subNodes: [],
                        defaultName: '<Default Value>', // Placeholder for default value, any node with a defaultName prop can be reset to this value from the right-click menu
                        defaultToRightClickMenu: true, // This node can be renamed from the right-click menu
                    },
                ],
            },
        ]
    },
    csvUploaderField: {
        id: 'customisation-csv-uploader-field',
        name: 'Field Heading',
        path: 'customisation.csv-uploader-field',
        enabled: true,
        renamable: true,
        removable: true,
        hasChildren: true,
        subNodes: [
            {
                id: 'customisation-csv-uploader-field-description',
                name: '[CSV Uploader Field]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-csv-uploader-field-data-link',
                name: '<Not Linked>',
                path: 'data-link', 
                enabled: true,
                linkable: true, // This node can be linked to a legacy data node path
                link: null,     // Initially no link
            },
        ]
    }
}

export const addCustomFieldButton = {
    id: 'customisation-module-custom-add-field',
    name: 'Add Custom Field',
    isAddButton: true,
    path: 'customisation.module.custom.add-field',
    enabled: true,
    alwaysAtBottom: true,
    clickAction: "add-customisation-custom-field",
    defaultToRightClickMenu: true,
}

export const CUSTOMISATION_MODULES = {
    custom: {
        id: 'customisation-module-custom',
        name: 'Custom Module',
        path: 'customisation.module.custom',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-custom-description',
                name: '[Custom Module]',
                enabled: false,
                alwaysAtTop: true,
            }
        ],
    },
    multiplesLinkage: {
        id: 'customisation-module-multiples-linkage',
        name: 'Group Linkage',
        path: 'customisation.module.multiples-linkage',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-multiples-linkage-data-link',
                name: '<Not Linked>',
                path: 'data-link', 
                enabled: true,
                linkable: true, // This node can be linked to a legacy data node path
                link: null,     // Initially no link
            },
        ]
    },
    interaction: {
        id: 'customisation-module-interaction',
        name: 'Interaction',
        path: 'customisation.module.interaction',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        renamable: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-interaction-description',
                name: '[Interaction Module]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-interaction-mode-dropdown',
                name: 'Mode',
                type: 'dropdown',
                hasChildren: true,
                enabled: true,
                renamable: true,
                draggable: true,
                removable: true,
                subNodes: [
                    {
                        id: 'mode-dropdown-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                    }
                ]
            }
        ],
    },
    position: {
        id: 'customisation-module-position',
        name: 'Position',
        path: 'customisation.module.position',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-position-description',
                name: '[Position Module]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-position-position',
                name: 'Position',
                enabled: true,
                hasChildren: true,
                subNodes: [
                    {
                        id: 'position-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                    },
                    {
                        id: 'customisation-module-position-position-top-left',
                        name: 'Top Left Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'top-left-value',
                                name: '<No Value>',
                                path: 'top.left.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['topleft', 'lefttop'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-top-center',
                        name: 'Top Center Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'top-center-value',
                                name: '<No Value>',
                                path: 'top.center.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['topcenter', 'centertop', 'top'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-top-right',
                        name: 'Top Right Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'top-right-value',
                                name: '<No Value>',
                                path: 'top.right.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['topright', 'righttop'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-center-left',
                        name: 'Center Left Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'center-left-value',
                                name: '<No Value>',
                                path: 'center.left.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['centerleft', 'leftcenter', 'middleleft', 'leftmiddle', 'left'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-center',
                        name: 'Center Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'center-value',
                                name: '<No Value>',
                                path: 'center.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['center', 'middle', 'mid', 'centermiddle', 'middlecenter'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-center-right',
                        name: 'Center Right Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'center-right-value',
                                name: '<No Value>',
                                path: 'center.right.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['centerright', 'rightcenter', 'middleright', 'rightmiddle', 'right'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-bottom-left',
                        name: 'Bottom Left Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'bottom-left-value',
                                name: '<No Value>',
                                path: 'bottom.left.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['bottomleft', 'leftbottom'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-bottom-center',
                        name: 'Bottom Center Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'bottom-center-value',
                                name: '<No Value>',
                                path: 'bottom.center.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['bottomcenter', 'centerbottom', 'bottom'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-position-position-bottom-right',
                        name: 'Bottom Right Value',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['position', 'pos', 'positioning', 'positional', 'positionsettings', 'location'],
                        subNodes: [
                            {
                                id: 'bottom-right-value',
                                name: '<No Value>',
                                path: 'bottom.right.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['bottomright', 'rightbottom'],
                            },
                        ]
                    },
                ]
            },
            {
                id: 'customisation-module-position-offset',
                name: 'Offset',
                path: 'customisation.module.position.offset',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'offset-x',
                        name: 'X',
                        path: 'customisation.module.position.offset.x',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'offset-x-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['offsetx', 'xoffset', 'x', 'xpos'],
                            },
                        ]
                    },
                    {
                        id: 'offset-y',
                        name: 'Y',
                        path: 'customisation.module.position.offset.y',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'offset-y-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['offsety', 'yoffset', 'y', 'ypos'],
                            },
                        ]
                    }
                ]
            },
            {
                id: 'customisation-module-position-alignment',
                name: 'Alignment',
                path: 'customisation.module.position.alignment',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'alignment-x',
                        name: 'Horizontal',
                        path: 'customisation.module.position.alignment.x',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'alignment-x-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['alignmentx', 'xalignment', 'x-alignment', 'alignment-x', 'alignx', 'xalign'],
                            },
                            {
                                id: 'alignment-left',
                                name: 'Left Value',
                                path: 'customisation.module.position.alignment.x.left',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmentx', 'xalignment', 'x-alignment', 'alignment-x', 'alignx', 'xalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-left-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.x.left.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['left', 'alignmentleft', 'leftalignment', 'left-alignment', 'alignment-left', 'leftalign', 'leftaligned', 'alignleft', 'alignedleft'],
                                    },
                                ]
                            },
                            {
                                id: 'alignment-center',
                                name: 'Center Value',
                                path: 'customisation.module.position.alignment.x.center',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmentx', 'xalignment', 'x-alignment', 'alignment-x', 'alignx', 'xalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-center-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.x.center.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['center', 'alignmentcenter', 'centeralignment', 'center-alignment', 'alignment-center', 'centeralign', 'centeraligned', 'aligncenter', 'alignedcenter'],
                                    },
                                ]
                            },
                            {
                                id: 'alignment-right',
                                name: 'Right Value',
                                path: 'customisation.module.position.alignment.x.right',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmentx', 'xalignment', 'x-alignment', 'alignment-x', 'alignx', 'xalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-right-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.x.right.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['right', 'alignmentright', 'rightalignment', 'right-alignment', 'alignment-right', 'rightalign', 'rightaligned', 'alignright', 'alignedright'],
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        id: 'alignment-y',
                        name: 'Vertical',
                        path: 'customisation.module.position.alignment.y',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'alignment-y-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['alignmenty', 'yalignment', 'y-alignment', 'alignment-y', 'aligny', 'yalign'],
                            },
                            {
                                id: 'alignment-top',
                                name: 'Top Value',
                                path: 'customisation.module.position.alignment.y.top',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmenty', 'yalignment', 'y-alignment', 'alignment-y', 'aligny', 'yalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-top-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.y.top.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['top', 'alignmenttop', 'topalignment', 'top-alignment', 'alignment-top', 'topalign', 'topaligned', 'aligntop', 'alignedtop'],
                                    },
                                ]
                            },
                            {
                                id: 'alignment-middle',
                                name: 'Middle Value',
                                path: 'customisation.module.position.alignment.y.middle',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmenty', 'yalignment', 'y-alignment', 'alignment-y', 'aligny', 'yalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-middle-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.y.middle.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['middle', 'alignmentmiddle', 'middlealignment', 'middle-alignment', 'alignment-middle', 'middlealign', 'middlealigned', 'alignmiddle', 'alignedmiddle'],
                                    },
                                ]
                            },
                            {
                                id: 'alignment-bottom',
                                name: 'Bottom Value',
                                path: 'customisation.module.position.alignment.y.bottom',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignmenty', 'yalignment', 'y-alignment', 'alignment-y', 'aligny', 'yalign'],
                                subNodes: [
                                    {
                                        id: 'alignment-bottom-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.position.alignment.y.bottom.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['bottom', 'alignmentbottom', 'bottomalignment', 'bottom-alignment', 'alignment-bottom', 'bottomalign', 'bottomaligned', 'alignbottom', 'alignedbottom'],
                                    },
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    dimensions: {
        id: 'customisation-module-dimensions',
        name: 'Dimensions',
        path: 'customisation.module.dimensions',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-dimensions-description',
                name: '[Dimensions Module]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-dimensions-dimensions',
                name: 'Dimensions',
                enabled: true,
                hasChildren: true,
                subNodes: [
                    {
                        id: 'dimensions-width',
                        name: 'W',
                        path: 'customisation.module.dimensions.width',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'width-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['width', 'length', 'w', 'dimensionwidth', 'widthdimension', 'dimensionswidth', 'dimensions-w', 'sizex', 'xsize'],
                            },
                        ]
                    },
                    {
                        id: 'dimensions-height',
                        name: 'H',
                        path: 'customisation.module.dimensions.height',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'height-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['height', 'thickness', 'h', 'dimensionheight', 'heightdimension', 'dimensionsheight', 'dimensions-h', 'sizey', 'ysize'],
                            },
                        ]
                    }
                ]
            }
        ]
    },
    appearance: {
        id: 'customisation-module-appearance',
        name: 'Appearance',
        path: 'customisation.module.appearance',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-appearance-description',
                name: '[Appearance Module]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-appearance-opacity',
                name: 'Opacity',
                path: 'customisation.module.appearance.opacity',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'opacity-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['opacity', 'op', 'transparency', 'translucency', 'alpha'],
                    },
                ]
            },
            {
                id: 'customisation-module-appearance-corner-radius',
                name: 'Corner Radius',
                path: 'customisation.module.appearance.corner-radius',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'corner-radius-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['cornerradius', 'cornerradiusvalue', 'corner-radius', 'corner-radius-value', 'radius', 'corner', 'roundness', 'corners'],
                    },
                ]
            },
        ]
    },
    typography: {
        id: 'customisation-module-typography',
        name: 'Typography',
        path: 'customisation.module.typography',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-typography-description',
                name: '[Typography Module]',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-typography-font',
                name: 'Font',
                path: 'customisation.module.typography.font',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-typography-font-face',
                        name: 'Face',
                        path: 'customisation.module.typography.font.face',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'font-face-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['font', 'fontface', 'font-face', 'typeface', 'fontfamily', 'font-family', 'typefacefamily', 'mainFont', 'headerFont'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-typography-font-weight',
                        name: 'Weight',
                        path: 'customisation.module.typography.font.weight',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'customisation-module-typography-font-weight-narrow',
                                name: 'Narrow',
                                path: 'customisation.module.typography.font.weight.narrow',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['fontweight', 'weight', 'boldness'],
                                subNodes: [
                                    {
                                        id: 'font-weight-narrow-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['fontweight', 'weight', 'boldness'],
                                    },
                                    {
                                        id: 'font-weight-narrow-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.font.weight.narrow.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['narrow', 'thin', 'light', 'fontweightnarrow', 'fontweightthin', 'fontweightlight'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-font-weight-normal',
                                name: 'Normal',
                                path: 'customisation.module.typography.font.weight.normal',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['fontweight', 'weight', 'boldness', 'bold', 'isbold', 'headerisbold', 'mainfontisbold'],
                                subNodes: [
                                    {
                                        id: 'font-weight-normal-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['fontweight', 'weight', 'boldness', 'bold', 'isbold', 'headerisbold', 'mainfontisbold'],
                                    },
                                    {
                                        id: 'font-weight-normal-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.font.weight.normal.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['normal', 'regular', 'standard', 'fontweightnormal', 'fontweightregular', 'fontweightstandard', 'false'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-font-weight-bold',
                                name: 'Bold',
                                path: 'customisation.module.typography.font.weight.bold',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['fontweight', 'weight', 'boldness', 'bold', 'isbold', 'headerisbold', 'mainfontisbold'],
                                subNodes: [
                                    {
                                        id: 'font-weight-bold-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['fontweight', 'weight', 'boldness', 'bold', 'isbold', 'headerisbold', 'mainfontisbold'],
                                    },
                                    {
                                        id: 'font-weight-bold-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.font.weight.bold.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['bold', 'strong', 'fontweightbold', 'fontweightstrong', 'true'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                id: 'customisation-module-typography-size',
                name: 'Size',
                path: 'customisation.module.typography.size',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'size-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['size', 'fontsize', 'textsize', 'mainFontSize', 'headerFontSize'],
                    },
                ]
            },
            {
                id: 'customisation-module-typography-line-height',
                name: 'Line Height',
                path: 'customisation.module.typography.line-height',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'line-height-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['lineheight', 'line-height', 'textlineheight', 'text-line-height', 'mainlineheight', 'headerlineheight'],
                    },
                ]
            },
            {
                id: 'customisation-module-typography-text-alignment',
                name: 'Alignment',
                path: 'customisation.module.typography.text-alignment',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-typography-text-alignment.horizontal',
                        name: 'Horizontal',
                        path: 'customisation.module.typography.text-alignment.horizontal',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'customisation-module-typography-text-alignment-horizontal.left',
                                name: 'Left',
                                path: 'customisation.module.typography.text-alignment.horizontal.left',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignment', 'textalignment', 'copyalign', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-left-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['alignment', 'textalignment', 'copyalign', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-left-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.horizontal.left.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['left', 'alignmentleft', 'leftalignment', 'leftalign', 'leftaligned', 'alignleft', 'alignedleft'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-text-alignment-horizontal.center',
                                name: 'Center',
                                path: 'customisation.module.typography.text-alignment.horizontal.center',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignment', 'textalignment', 'copyalign', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-center-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['alignment', 'textalignment', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-center-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.horizontal.center.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['center', 'alignmentcenter', 'centeralignment', 'centeralign', 'centeraligned', 'aligncenter', 'alignedcenter'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-text-alignment-horizontal.right',
                                name: 'Right',
                                path: 'customisation.module.typography.text-alignment.horizontal.right',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['alignment', 'textalignment', 'copyalign', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-right-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['alignment', 'textalignment', 'copyalign', 'horizontalalignment', 'texthorizontalalignment', 'textalignhorizontal', 'horizontaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-horizontal-right-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.horizontal.right.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['right', 'alignmentright', 'rightalignment', 'rightalign', 'rightaligned', 'alignright', 'alignedright'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-typography-text-alignment.vertical',
                        name: 'Vertical',
                        path: 'customisation.module.typography.text-alignment.vertical',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'customisation-module-typography-text-alignment-vertical.top',
                                name: 'Top',
                                path: 'customisation.module.typography.text-alignment.vertical.top',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-top-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-top-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.vertical.top.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['top', 'alignmenttop', 'topalignment', 'topalign', 'topaligned', 'aligntop', 'alignedtop'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-text-alignment-vertical.middle',
                                name: 'Middle',
                                path: 'customisation.module.typography.text-alignment.vertical.middle',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-middle-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-middle-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.vertical.middle.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['middle', 'alignmentmiddle', 'middlealignment', 'middlealign', 'middlealigned', 'alignmiddle', 'alignedmiddle', 'center', 'alignmentcenter', 'centeralignment', 'centeralign', 'centeraligned', 'aligncenter', 'alignedcenter'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'customisation-module-typography-text-alignment-vertical.bottom',
                                name: 'Bottom',
                                path: 'customisation.module.typography.text-alignment.vertical.bottom',
                                hasChildren: true,
                                enabled: true,
                                autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                subNodes: [
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-bottom-data-link',
                                        name: '<Not Linked>',
                                        path: 'data-link',
                                        enabled: true,
                                        linkable: true, // This node can be linked to a legacy data node path
                                        link: null,     // Initially no link
                                        autoDiscover: ['verticalalignment', 'textverticalalignment', 'textalignvertical', 'verticaltextalign'],
                                    },
                                    {
                                        id: 'customisation-module-typography-text-alignment-vertical-bottom-value',
                                        name: '<No Value>',
                                        path: 'customisation.module.typography.text-alignment.vertical.bottom.value',
                                        enabled: true,
                                        renamable: true,
                                        valueLink: true,
                                        autoDiscover: ['bottom', 'alignmentbottom', 'bottomalignment', 'bottomalign', 'bottomaligned', 'alignbottom', 'alignedbottom'],
                                    },
                                    {
                                        id: 'default-setting',
                                        name: 'UNLINKED DEFAULT',
                                        path: 'default-setting',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'default-setting-value',
                                                name: 'False',
                                                path: 'default-setting.value',
                                                enabled: true,
                                                isBoolean: true, // This node is a boolean value
                                                booleanValue: false, // Initial value
                                                defaultToRightClickMenu: true, // This node can be toggled from the right-click menu
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                id: 'customisation-module-typography-text-color',
                name: 'Text Color',
                path: 'customisation.module.typography.text-color',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'text-color-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['textcolor', 'color', 'foregroundcolor', 'textforegroundcolor', 'fontcolor', 'textfontcolor', 'mainfontcolor', 'headerfontcolor', 'textcolour', 'colour', 'foregroundcolour', 'textforegroundcolour', 'fontcolour', 'textfontcolour', 'mainfontcolour', 'headerfontcolour'],
                    },
                ]
            }
        ]
    },
    fill: {
        id: 'customisation-module-fill',
        name: 'Background',
        path: 'customisation.module.fill',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,
        subNodes: [
            {
                id: 'customisation-module-fill-description',
                name: '[Fill Module]',
                path: 'customisation.module.fill.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-fill-type',
                name: 'Type Settings',
                path: 'customisation.module.fill.type',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-fill-type-unlinked-value',
                        name: '<User Editable Value>',
                        path: 'customisation.module.fill.type.unlinked-value',
                        enabled: true,
                        isEnum: true, // This node is an enum type
                        enumValues: ['Solid', 'Gradient', 'Stripes', 'Image', '<User Editable Value>'],
                        enumValue: '<User Editable Value>',
                        defaultToRightClickMenu: true,
                    },
                    {
                        id: 'customisation-module-fill-type-solid',
                        name: 'Solid',
                        path: 'customisation.module.fill.type.solid',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue', 'useimage', 'useimagebg', 'imagebg', 'imagebackground', 'backgroundimage'],
                        subNodes: [
                            {
                                id: 'customisation-module-fill-type-solid-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue', 'useimage', 'useimagebg', 'imagebg', 'imagebackground', 'backgroundimage'],
                            },
                            {
                                id: 'customisation-module-fill-type-solid-value',
                                name: '<No Value>',
                                path: 'customisation.module.fill.type.solid.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['solid', 'solidcolor', 'solidcolour', 'filltypesolid', 'backgroundsolid', 'backgroundtypesolid', 'false'],
                            },
                            {
                                id: 'customisation-module-fill-type-solid-options',
                                name: 'Options',
                                path: 'customisation.module.fill.type.solid.options',
                                hasChildren: true,
                                enabled: true,
                                subNodes: [
                                    {
                                        id: 'customisation-module-fill-type-solid-options-color',
                                        name: 'Color',
                                        path: 'customisation.module.fill.type.solid.options.color',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-solid-options-color-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['color', 'fillcolor', 'fillcolour', 'backgroundcolor', 'backgroundcolour', 'bgcolor', 'bgcolour', 'mainbgcolor', 'headerbgcolor', 'solidcolor', 'solidcolour'],
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: 'customisation-module-fill-type-gradient',
                        name: 'Gradient',
                        path: 'customisation.module.fill.type.gradient',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue'],
                        subNodes: [
                            {
                                id: 'customisation-module-fill-type-gradient-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue'],
                            },
                            {
                                id: 'customisation-module-fill-type-gradient-value',
                                name: '<No Value>',
                                path: 'customisation.module.fill.type.gradient.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['gradient', 'backgroundgradient', 'fillgradient', 'gradientfill'],
                            },
                            {
                                id: 'customisation-module-fill-type-gradient-options',
                                name: 'Options',
                                path: 'customisation.module.fill.type.gradient.options',
                                hasChildren: true,
                                enabled: true,
                                subNodes: [
                                    {
                                        id: 'customisation-module-fill-type-gradient-options-color1',
                                        name: 'Color 1',
                                        path: 'customisation.module.fill.type.gradient.options.color1',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-gradient-options-color1-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['color1', 'colour1', 'fillcolor1', 'fillcolour1', 'backgroundcolor1', 'backgroundcolour1', 'bgcolor1', 'bgcolour1', 'mainbgcolor1', 'headerbgcolor1', 'gradientcolor1', 'gradientcolour1', 'bggradientcolor1', 'bggradientcolour1', 'gradientfillcolor1', 'gradientfillcolour1', 'bggradientfrom'],
                                            }
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-gradient-options-color2',
                                        name: 'Color 2',
                                        path: 'customisation.module.fill.type.gradient.options.color2',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-gradient-options-color2-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['color2', 'colour2', 'fillcolor2', 'fillcolour2', 'backgroundcolor2', 'backgroundcolour2', 'bgcolor2', 'bgcolour2', 'mainbgcolor2', 'headerbgcolor2', 'gradientcolor2', 'gradientcolour2', 'bggradientcolor2', 'bggradientcolour2', 'gradientfillcolor2', 'gradientfillcolour2', 'bggradientto'],
                                            }
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-gradient-options-angle',
                                        name: 'Angle',
                                        path: 'customisation.module.fill.type.gradient.options.angle',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-gradient-options-angle-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['angle', 'gradientangle', 'bggradientangle', 'gradientfillangle'],
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: 'customisation-module-fill-type-stripes',
                        name: 'Stripes',
                        path: 'customisation.module.fill.type.stripes',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue'],
                        subNodes: [
                            {
                                id: 'customisation-module-fill-type-stripes-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue'],
                            },
                            {
                                id: 'customisation-module-fill-type-stripes-value',
                                name: '<No Value>',
                                path: 'customisation.module.fill.type.stripes.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['stripes', 'striped', 'stripedfill', 'stripedbackground', 'backgroundstripes', 'backgroundstriped', 'fillstripes', 'fillstriped'],
                            },
                            {
                                id: 'customisation-module-fill-type-stripes-options',
                                name: 'Options',
                                path: 'customisation.module.fill.type.stripes.options',
                                hasChildren: true,
                                enabled: true,
                                subNodes: [
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-color1',
                                        name: 'Color 1',
                                        path: 'customisation.module.fill.type.stripes.options.color1',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-color1-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['stripedcolor1', 'stripedcolour1', 'bgstripedcolor1', 'bgstripedcolour1', 'stripedfillcolor1', 'stripedfillcolour1', 'stripecolor1', 'stripecolour1', 'bgstripecolor1', 'bgstripecolour1', 'stripescolor1', 'stripescolour1', 'bgstripescolor1', 'bgstripescolour1', 'color1', 'colour1', 'fillcolor1', 'fillcolour1', 'backgroundcolor1', 'backgroundcolour1', 'bgcolor1', 'bgcolour1', 'mainbgcolor1', 'headerbgcolor1'],
                                            },
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-color2',
                                        name: 'Color 2',
                                        path: 'customisation.module.fill.type.stripes.options.color2',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-color2-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['stripedcolor2', 'stripedcolour2', 'bgstripedcolor2', 'bgstripedcolour2', 'stripedfillcolor2', 'stripedfillcolour2', 'stripecolor2', 'stripecolour2', 'bgstripecolor2', 'bgstripecolour2', 'stripescolor2', 'stripescolour2', 'bgstripescolor2', 'bgstripescolour2', 'color2', 'colour2', 'fillcolor2', 'fillcolour2', 'backgroundcolor2', 'backgroundcolour2', 'bgcolor2', 'bgcolour2', 'mainbgcolor2', 'headerbgcolor2'],
                                            },
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-diagonal',
                                        name: 'Diagonal',
                                        path: 'customisation.module.fill.type.stripes.options.diagonal',
                                        hasChildren: true,
                                        enabled: true,
                                        autoDiscover: ['bgstripedirection', 'stripedirection', 'bgstripesdirection', 'stripesdirection', 'stripeddiagonal', 'bgstripeddiagonal', 'stripedfilldiagonal', 'stripecdiagonal', 'bgstripecdiagonal', 'stripesdiagonal', 'bgstripesdiagonal', 'diagonalstripes', 'diagonalstripe', 'diagonalstriped'],
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-diagonal-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['bgstripedirection', 'stripedirection', 'bgstripesdirection', 'stripesdirection', 'stripeddiagonal', 'bgstripeddiagonal', 'stripedfilldiagonal', 'stripecdiagonal', 'bgstripecdiagonal', 'stripesdiagonal', 'bgstripesdiagonal', 'diagonalstripes', 'diagonalstripe', 'diagonalstriped'],
                                            },
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-diagonal-value',
                                                name: '<No Value>',
                                                path: 'customisation.module.fill.type.stripes.options.diagonal.value',
                                                enabled: true,
                                                renamable: true,
                                                valueLink: true,
                                                autoDiscover: ['diagonal', 'stripediagonal', 'bgstripediagonal', 'stripedfilldiagonal', 'stripecdiagonal', 'bgstripecdiagonal', 'stripesdiagonal', 'bgstripesdiagonal', 'true', 'diagonalstripes', 'diagonalstripe', 'diagonalstriped'],
                                            }
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-straight',
                                        name: 'Straight',
                                        path: 'customisation.module.fill.type.stripes.options.straight',
                                        hasChildren: true,
                                        enabled: true,
                                        autoDiscover: ['bgstripedirection', 'stripedirection', 'bgstripesdirection', 'stripesdirection', 'stripeddiagonal', 'bgstripeddiagonal', 'stripedfilldiagonal', 'stripecdiagonal', 'bgstripecdiagonal', 'stripesdiagonal', 'bgstripesdiagonal', 'diagonalstripes', 'diagonalstripe', 'diagonalstriped'],
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-straight-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['bgstripedirection', 'stripedirection', 'bgstripesdirection', 'stripesdirection', 'stripeddiagonal', 'bgstripeddiagonal', 'stripedfilldiagonal', 'stripecdiagonal', 'bgstripecdiagonal', 'stripesdiagonal', 'bgstripesdiagonal', 'diagonalstripes', 'diagonalstripe', 'diagonalstriped'],
                                            },
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-straight-value',
                                                name: '<No Value>',
                                                path: 'customisation.module.fill.type.stripes.options.straight.value',
                                                enabled: true,
                                                renamable: true,
                                                valueLink: true,
                                                autoDiscover: ['straight', 'stripedstraight', 'bgstripedstraight', 'stripedfillstraight', 'stripecstraight', 'bgstripecstraight', 'stripesstraight', 'bgstripesstraight', 'false', 'straightstripes', 'straightstripe', 'straightstriped'],
                                            }
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-angle',
                                        name: 'Angle',
                                        path: 'customisation.module.fill.type.stripes.options.angle',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-angle-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['stripedangle', 'bgstripedangle', 'stripedfillangle', 'stripecangle', 'bgstripecangle', 'stripesangle', 'bgstripesangle'],
                                            },
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-stripes-options-width',
                                        name: 'Stripe Width',
                                        path: 'customisation.module.fill.type.stripes.options.width',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-stripes-options-width-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['stripedwidth', 'bgstripedwidth', 'stripedfillwidth', 'stripecwidth', 'bgstripecwidth', 'stripeswidth', 'bgstripeswidth'],
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: 'customisation-module-fill-type-image',
                        name: 'Image',
                        path: 'customisation.module.fill.type.image',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue', 'useimage', 'useimagebg', 'imagebg', 'imagebackground', 'backgroundimage'],
                        subNodes: [
                            {
                                id: 'customisation-module-fill-type-image-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['filltype', 'bgfilltype', 'backgroundfilltype', 'filltypevalue', 'backgroundtype', 'backgroundtypevalue', 'useimage', 'useimagebg', 'imagebg', 'imagebackground', 'backgroundimage'],
                            },
                            {
                                id: 'customisation-module-fill-type-image-value',
                                name: '<No Value>',
                                path: 'customisation.module.fill.type.image.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['image', 'backgroundimage', 'fillimage', 'imagefill', 'useimage', 'useimagebg', 'imagebg', 'imagebackground', 'true'],
                            },
                            {
                                id: 'customisation-module-fill-type-image-options',
                                name: 'Options',
                                path: 'customisation.module.fill.type.image.options',
                                hasChildren: true,
                                enabled: true,
                                subNodes: [
                                    {
                                        id: 'customisation-module-fill-type-image-options-image',
                                        name: 'Image',
                                        path: 'customisation.module.fill.type.image.options.image',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-image-options-image-data-link',
                                                name: '<Not Linked>',
                                                path: 'data-link',
                                                enabled: true,
                                                linkable: true, // This node can be linked to a legacy data node path
                                                link: null,     // Initially no link
                                                autoDiscover: ['image', 'imagefile', 'bgfilename', 'filename', 'imagefilename', 'backgroundimage', 'fillimage', 'imagefill'],
                                            },
                                        ]
                                    },
                                    {
                                        id: 'customisation-module-fill-type-image-options-fill-style',
                                        name: 'Fill Style',
                                        path: 'customisation.module.fill.type.image.options.fill-style',
                                        hasChildren: true,
                                        enabled: true,
                                        subNodes: [
                                            {
                                                id: 'customisation-module-fill-type-image-options-tile',
                                                name: 'Tile',
                                                path: 'customisation.module.fill.type.image.options.tile',
                                                hasChildren: true,
                                                enabled: true,
                                                autoDiscover: ['bgtileimage', 'tileimage', 'tilebgimage', 'imagefillstyle', 'fillstyle', 'repeat', 'bgrepeat', 'tile', 'bgtile', 'tileimage'],
                                                subNodes: [
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-tile-data-link',
                                                        name: '<Not Linked>',
                                                        path: 'data-link',
                                                        enabled: true,
                                                        linkable: true, // This node can be linked to a legacy data node path
                                                        link: null,     // Initially no link
                                                        autoDiscover: ['bgtileimage', 'tileimage', 'tilebgimage', 'imagefillstyle', 'fillstyle', 'repeat', 'bgrepeat', 'tile', 'bgtile', 'tileimage'],
                                                    },
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-tile-value',
                                                        name: '<No Value>',
                                                        path: 'customisation.module.fill.type.image.options.tile.value',
                                                        enabled: true,
                                                        renamable: true,
                                                        valueLink: true,
                                                        autoDiscover: ['bgtileimage', 'tileimage', 'tilebgimage', 'imagefillstyle', 'fillstyle', 'repeat', 'bgrepeat', 'tile', 'bgtile', 'tileimage', 'true'],
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'customisation-module-fill-type-image-options-contain',
                                                name: 'Contain',
                                                path: 'customisation.module.fill.type.image.options.contain',
                                                hasChildren: true,
                                                enabled: true,
                                                autoDiscover: ['bgtileimage', 'tileimage', 'tilebgimage', 'imagefillstyle', 'fillstyle', 'repeat', 'bgrepeat', 'tile', 'bgtile', 'tileimage'],
                                                subNodes: [
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-contain-data-link',
                                                        name: '<Not Linked>',
                                                        path: 'data-link',
                                                        enabled: true,
                                                        linkable: true, // This node can be linked to a legacy data node path
                                                        link: null,     // Initially no link
                                                        autoDiscover: ['bgtileimage', 'tileimage', 'tilebgimage', 'imagefillstyle', 'fillstyle', 'repeat', 'bgrepeat', 'tile', 'bgtile', 'tileimage'],
                                                    },
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-contain-value',
                                                        name: '<No Value>',
                                                        path: 'customisation.module.fill.type.image.options.contain.value',
                                                        enabled: true,
                                                        renamable: true,
                                                        valueLink: true,
                                                        autoDiscover: ['contain', 'bgcontain', 'imagecontain', 'containimage', 'containbg', 'containfillstyle', 'fillstylecontain', 'false'],
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'customisation-module-fill-type-image-options-cover',
                                                name: 'Cover',
                                                path: 'customisation.module.fill.type.image.options.cover',
                                                hasChildren: true,
                                                enabled: true,
                                                autoDiscover: ['imagefillstyle', 'fillstyle'],
                                                subNodes: [
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-cover-data-link',
                                                        name: '<Not Linked>',
                                                        path: 'data-link',
                                                        enabled: true,
                                                        linkable: true, // This node can be linked to a legacy data node path
                                                        link: null,     // Initially no link
                                                        autoDiscover: ['imagefillstyle', 'fillstyle'],
                                                    },
                                                    {
                                                        id: 'customisation-module-fill-type-image-options-cover-value',
                                                        name: '<No Value>',
                                                        path: 'customisation.module.fill.type.image.options.cover.value',
                                                        enabled: true,
                                                        renamable: true,
                                                        valueLink: true,
                                                        autoDiscover: ['cover', 'bgcover', 'imagecover', 'coverimage', 'coverbg', 'coverfillstyle', 'fillstylecover'],
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                id: 'customisation-module-fill-opacity',
                name: 'Opacity',
                path: 'customisation.module.fill.opacity',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-fill-opacity-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['boxOpacity', 'bgOpacity', 'mainBoxOpacity', 'fillopacity', 'bgfillopacity', 'backgroundfillopacity', 'opacity', 'modulefillopacity', 'modulebgfillopacity', 'fillalpha', 'bgfillalpha', 'backgroundfillalpha', 'alpha', 'filltransparency', 'bgfilltransparency', 'backgroundfilltransparency', 'filltransparency'],
                    },
                ]
            }
        ]
    },
    border: {
        id: 'customisation-module-border',
        name: 'Border',
        path: 'customisation.module.border',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,
        subNodes: [
            {
                id: 'customisation-module-border-description',
                name: '[Border Module]',
                path: 'customisation.module.border.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-border-color',
                name: 'Color',
                path: 'customisation.module.border.color',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-border-color-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['bordercolor', 'borderColour', 'color', 'colour'],
                    },
                ]
            },
            {
                id: 'customisation-module-border-opacity',
                name: 'Opacity',
                path: 'customisation.module.border.opacity',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-border-opacity-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['borderOpacity', 'borderopacity', 'borderAlpha', 'borderalpha', 'borderTransparency', 'bordertransparency', ],
                    },
                ]
            },
            {
                id: 'customisation-module-border-position',
                name: 'Position',
                path: 'customisation.module.border.position',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-border-position-outside',
                        name: 'Outside',
                        path: 'customisation.module.border.position.outside',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['outlineposition', 'borderposition', 'borderposition', 'borderpos', 'borderpos', 'borderLocation', 'borderlocation', 'innerborder'],
                        subNodes: [
                            {
                                id: 'customisation-module-border-position-outside-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['outlineposition', 'borderposition', 'borderposition', 'borderpos', 'borderpos', 'borderLocation', 'borderlocation', 'innerborder'],
                            },
                            {
                                id: 'customisation-module-border-position-outside-value',
                                name: '<No Value>',
                                path: 'customisation.module.border.position.outside.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['outside', 'borderoutside', 'borderout', 'borderout', 'outerborder', 'outerborder', 'outer', 'False', 'false'],
                            }
                        ]
                    },
                    {
                        id: 'customisation-module-border-position-inside',
                        name: 'Inside',
                        path: 'customisation.module.border.position.inside',
                        hasChildren: true,
                        enabled: true,
                        autoDiscover: ['borderposition', 'borderposition', 'borderpos', 'borderpos', 'borderlocation', 'borderlocation', 'innerborder'],
                        subNodes: [
                            {
                                id: 'customisation-module-border-position-inside-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['borderposition', 'borderposition', 'borderpos', 'borderpos', 'borderlocation', 'borderlocation', 'innerborder'],
                            },
                            {
                                id: 'customisation-module-border-position-inside-value',
                                name: '<No Value>',
                                path: 'customisation.module.border.position.inside.value',
                                enabled: true,
                                renamable: true,
                                valueLink: true,
                                autoDiscover: ['inside', 'borderinside', 'borderin', 'borderin', 'innerborder', 'innerborder', 'inner', 'True', 'true'],
                            }
                        ]
                    },
                ]
            },
            {
                id: 'customisation-module-border-thickness',
                name: 'Thickness',
                path: 'customisation.module.border.thickness',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-border-thickness-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['borderthickness', 'borderwidth', 'thickness', 'linewidth', 'outlinewidth', 'linethickness', 'outlineThickness', ],
                    },
                ]
            },
        ]
    },
    shadow: {
        id: 'customisation-module-shadow',
        name: 'Shadow',
        path: 'customisation.module.shadow',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,
        subNodes: [
            {
                id: 'customisation-module-shadow-description',
                name: '[Shadow Module]',
                path: 'customisation.module.shadow.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-shadow-color',
                name: 'Color',
                path: 'customisation.module.shadow.color',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-shadow-color-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['shadowcolor', 'shadowcolour', 'shadowcolor', 'shadowcolour', 'shadowcolorhex', 'shadowcolourhex', 'shadowcolorHex', 'shadowcolourhex', 'boxshadowcolor', 'boxshadowcolour', 'boxshadowcolorhex', 'boxshadowcolourhex'],
                    },
                ]
            },
            {
                id: 'customisation-module-shadow-opacity',
                name: 'Opacity',
                path: 'customisation.module.shadow.opacity',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-shadow-opacity-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['shadowOpacity', 'shadowopacity', 'shadowAlpha', 'shadowalpha', 'shadowtransparency', 'shadowtransparency', 'boxshadowopacity', 'boxshadowopacity', 'boxshadowalpha', 'boxshadowalpha', 'boxshadowtransparency', 'boxshadowtransparency'],
                    },
                ]
            },
            {
                id: 'customisation-module-shadow-position',
                name: 'Position',
                path: 'customisation.module.shadow.position',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-shadow-position-x',
                        name: 'X',
                        path: 'customisation.module.shadow.position.x',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'customisation-module-shadow-position-x-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['shadowx', 'xshadow','shadowpositionx', 'shadowpositionx', 'shadowposx', 'shadowposx', 'boxshadowpositionx', 'boxshadowpositionx', 'boxshadowposx', 'boxshadowposx', 'shadowpositionxvalue', 'shadowpositionxvalue', 'shadowposxvalue', 'shadowposxvalue'],
                            },
                        ]
                    },
                    {
                        id: 'customisation-module-shadow-position-y',
                        name: 'Y',
                        path: 'customisation.module.shadow.position.y',
                        hasChildren: true,
                        enabled: true,
                        subNodes: [
                            {
                                id: 'customisation-module-shadow-position-y-data-link',
                                name: '<Not Linked>',
                                path: 'data-link',
                                enabled: true,
                                linkable: true, // This node can be linked to a legacy data node path
                                link: null,     // Initially no link
                                autoDiscover: ['shadowy', 'yshadow','shadowpositiony', 'shadowpositiony', 'shadowposy', 'shadowposy', 'boxshadowpositiony', 'boxshadowpositiony', 'boxshadowposy', 'boxshadowposy', 'shadowpositionyvalue', 'shadowpositionyvalue', 'shadowposyvalue', 'shadowposyvalue'],
                            },
                        ]
                    },
                ]
            },
            {
                id: 'customisation-module-shadow-blur',
                name: 'Blur',
                path: 'customisation.module.shadow.blur',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-shadow-blur-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['shadowblur', 'shadowblur', 'boxshadowblur', 'boxshadowblur', 'shadowblurvalue', 'boxshadowblurvalue', 'shadowblurvalue'],
                    },
                ]
            },
            {
                id: 'customisation-module-shadow-spread',
                name: 'Spread',
                path: 'customisation.module.shadow.spread',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-shadow-spread-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['shadowspread', 'shadowspread', 'boxshadowspread', 'boxshadowspread', 'shadowspreadvalue', 'boxshadowspreadvalue', 'shadowspreadvalue'],
                    },
                ]
            },
        ]
    },
    padding: {
        id: 'customisation-module-padding',
        name: 'Padding',
        path: 'customisation.module.padding',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        subNodes: [
            {
                id: 'customisation-module-padding-description',
                name: '[Padding Module]',
                path: 'customisation.module.padding.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-padding-top',
                name: 'Top',
                path: 'customisation.module.padding.top',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-padding-top-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['paddingtop', 'paddingtop', 'boxpaddingtop', 'boxpaddingtop', 'paddingtopvalue', 'boxpaddingtopvalue', 'paddingtopvalue', 'paddingy', 'padding'],
                    }
                ]
            },
            {
                id: 'customisation-module-padding-right',
                name: 'Right',
                path: 'customisation.module.padding.right',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-padding-right-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['paddingright', 'paddingright', 'boxpaddingright', 'boxpaddingright', 'paddingrightvalue', 'boxpaddingrightvalue', 'paddingrightvalue', 'paddingx', 'padding'],
                    }
                ]
            },
            {
                id: 'customisation-module-padding-bottom',
                name: 'Bottom',
                path: 'customisation.module.padding.bottom',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-padding-bottom-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['paddingbottom', 'paddingbottom', 'boxpaddingbottom', 'boxpaddingbottom', 'paddingbottomvalue', 'boxpaddingbottomvalue', 'paddingbottomvalue', 'paddingy', 'padding'],
                    }
                ]
            },
            {
                id: 'customisation-module-padding-left',
                name: 'Left',
                path: 'customisation.module.padding.left',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-padding-left-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['paddingleft', 'paddingleft', 'boxpaddingleft', 'boxpaddingleft', 'paddingleftvalue', 'boxpaddingleftvalue', 'paddingleftvalue', 'paddingx', 'padding'],
                    }
                ]
            }
        ]
    },
    copy: {
        id: 'customisation-module-copy',
        name: 'Copy',
        path: 'customisation.module.copy',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,
        subNodes: [
            {
                id: 'customisation-module-copy-description',
                name: '[Copy Module]',
                path: 'customisation.module.copy.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-copy-data-link',
                name: '<Not Linked>',
                path: 'data-link',
                enabled: true,
                linkable: true, // This node can be linked to a legacy data node path
                link: null,     // Initially no link
                autoDiscover: ['copy', 'text', 'content', 'headercopy', 'footercopy', 'copytext', 'copycontent', 'copyheader', 'copyfooter', 'headertext', 'footertext', 'headercontent', 'footercontent', 'maincopy', 'maintext', 'maincontent'],
            },
            {
                id: 'customisation-module-copy-multi-line',
                name: 'Lines',
                path: 'customisation.module.copy.multi-line',
                enabled: true,
                hasChildren: true,
                subNodes: [
                    {
                        id: 'customisation-module-copy-multi-line.setting',
                        name: 'single',
                        path: 'customisation.module.copy.multi-line.setting',
                        enabled: true,
                        isEnum: true,
                        enumValues: ['single', 'multi'],
                        enumDefault: 'single',
                        enumValue: 'single', // Default value
                        defaultToRightClickMenu: true, // This node is a setting that can be set via the right-click menu
                    }
                ]
            }
        ]
    },
    animation: {
        id: 'customisation-module-animation',
        name: 'Animation',
        path: 'customisation.module.animation',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,
        subNodes: [
            {
                id: 'customisation-module-animation-description',
                name: '[Animation Module]',
                path: 'customisation.module.animation.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-animation-tween',
                name: 'Tween',
                path: 'customisation.module.animation.tween',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-animation-tween-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['type', 'tween', 'animationtween', 'animtween', 'tweenanimation', 'animationtween', 'animtween', 'tweentype', 'animationtype', 'animtype'],
                    },
                ]
            },
            {
                id: 'customisation-module-animation-duration',
                name: 'Duration',
                path: 'customisation.module.animation.duration',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-animation-duration-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['time', 'duration', 'animationduration', 'animduration', 'durationanimation', 'animationduration', 'animduration'],
                    },
                ]
            },
            {
                id: 'customisation-module-animation-delay',
                name: 'Delay',
                path: 'customisation.module.animation.delay',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-animation-delay-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['delay', 'animationdelay', 'animdelay', 'delayanimation', 'animationdelay', 'animdelay', 'delayanimation'],
                    },
                ]
            },
            {
                id: 'customisation-module-animation-easing',
                name: 'Easing',
                path: 'customisation.module.animation.easing',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-animation-easing-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['ease', 'easing', 'animationease', 'animease', 'easinganimation', 'animationeasing', 'animeasing'],
                    },
                ]
            },
        ]
    },
    audio: {
        id: 'customisation-module-audio',
        name: 'Audio',
        path: 'customisation.module.audio',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,

        subNodes: [
            {
                id: 'customisation-module-audio-description',
                name: '[Audio Module]',
                path: 'customisation.module.audio.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-audio-name',
                name: 'Name',
                path: 'customisation.module.audio.name',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-name-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['name', 'audioname', 'soundname', 'auname'],
                    },
                ]
            },
            {
                id: 'customisation-module-audio-enabled',
                name: 'Enabled',
                path: 'customisation.module.audio.enabled',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-enabled-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['enabled', 'play', 'isEnabled', 'isenabled', 'audioenabled', 'soundenabled', 'audioplay', 'soundplay', 'playaudio', 'playsound', 'playsfx', 'sfxplay'],
                    },
                ]
            },
            {
                id: 'customisation-module-audio-file',
                name: 'File',
                path: 'customisation.module.audio.file',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-file-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['file', 'filename', 'soundfilename', 'sfcfilename', 'audiofile', 'audiofilename'],
                    },
                ]
            },
            {
                id: 'customisation-module-audio-volume',
                name: 'Volume',
                path: 'customisation.module.audio.volume',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-volume-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['volume', 'audiovolume', 'soundvolume', 'sfxvolume'],
                    },
                ]
            },
            {
                id: 'customisation-module-audio-loop',
                name: 'Loop',
                path: 'customisation.module.audio.loop',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-loop-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['loop', 'audioloop', 'soundloop', 'sfxloop'],
                    },
                ]
            },
            {
                id: 'customisation-module-audio-delay',
                name: 'Delay',
                path: 'customisation.module.audio.delay',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-audio-delay-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['delay', 'audiodelay', 'sounddelay', 'sfxdelay'],
                    },
                ]
            },
        ]
    },
    disruptor: {
        id: 'customisation-module-disruptor',
        name: 'Disruptor',
        path: 'customisation.module.disruptor',
        customisationContainerType: 'module',
        hasChildren: true,
        enabled: true,
        draggable: true,
        removable: true,
        renamable: true,

        subNodes: [
            {
                id: 'customisation-module-disruptor-description',
                name: '[Disruptor Module]',
                path: 'customisation.module.disruptor.description',
                enabled: false,
                alwaysAtTop: true,
            },
            {
                id: 'customisation-module-disruptor-enabled',
                name: 'Enabled',
                path: 'customisation.module.disruptor.enabled',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-disruptor-enabled-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['enabled', 'play', 'isEnabled', 'isenabled', 'disruptorenabled', 'featureenabled', 'triggerdisruptor', 'triggerfeature', 'playdisruptor', 'playfeature'],
                    },
                ]
            },
            {
                id: 'customisation-module-disruptor-wait-for-end',
                name: 'Wait For End',
                path: 'customisation.module.disruptor.wait-for-end',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-disruptor-wait-for-end-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['waitForEnd', 'wait', 'waitTilEnd', 'waitUntilEnd', 'disruptorwaitforend', 'featurewaitforend'],
                    },
                ]
            },
            {
                id: 'customisation-module-disruptor-select',
                name: 'Disruptor',
                path: 'customisation.module.disruptor.select',
                hasChildren: true,
                enabled: true,
                subNodes: [
                    {
                        id: 'customisation-module-disruptor-select-data-link',
                        name: '<Not Linked>',
                        path: 'data-link',
                        enabled: true,
                        linkable: true, // This node can be linked to a legacy data node path
                        link: null,     // Initially no link
                        autoDiscover: ['disruptor', 'feature', 'disruptorid', 'featureid', 'triggerdisruptorfeatureid', 'triggerfeatureid'],
                    },
                ]
            },
        ]
    },
}

// Process final customisation config data back into a tree structure for use in the UI
export const fixNodeListDataFeatureIds = (featuresList, nodeListData = {}) => {
    console.log('Fixing node list data feature IDs from loaded nodeListData:', featuresList, nodeListData);

    for (const p in featuresList) {
        const feature = featuresList[p];
        const featureId = feature.feature._id;
        const instanceId = feature._id;
        const featureKey = feature.feature.varKey;

        // This code is actual related to taking our workspace config and restructuring out node list, something we are not tackling just yet
        /* const featureConfigs = [];
        for (const configKey in WorkspaceConfig) {
            if (WorkspaceConfig[configKey].featureKey === featureKey) {
                featureConfigs.push(WorkspaceConfig[configKey]);
            }
        }
        if (featureConfigs.length === 0) {
            console.warn(`No workspace config found for feature with key "${featureKey}". Skipping...`);
            continue;
        }
        console.log(`Found ${featureConfigs.length} workspace config(s) for feature with key "${featureKey}":`, featureConfigs); */

        // Do we have entries already for this feature in the node list data?
        // We can't rely on the prop keys, we need to check the first element in each array and see of the featureKey matches,
        // if so we can move this array to a new key based on the featureId, if not we need to create a new array for this featureId
        let nodeListDataKeyForThisFeature = null;
        for (const nodeListDataKey in nodeListData) {
            if (nodeListData[nodeListDataKey].length > 0 && nodeListData[nodeListDataKey][0].featureKey === featureKey) {
                nodeListDataKeyForThisFeature = nodeListDataKey;
                break;
            }
        }

        if (nodeListDataKeyForThisFeature !== featureId) {
            if (nodeListDataKeyForThisFeature) {
                console.log(`Found existing node list data key "${nodeListDataKeyForThisFeature}" for feature with key "${featureKey}". Moving it to a new key based on the feature ID...`);
                // Move this array to a new key based on the featureId
                nodeListData[featureId] = nodeListData[nodeListDataKeyForThisFeature];
                for (let i = 0; i < nodeListData[featureId].length; i++) {
                    nodeListData[featureId][i].id = featureId; // Update the id for each node in this array to match the new featureId key
                    nodeListData[featureId][i].path = featureId; // Update the path for each node in this array to match the new featureId key
                    nodeListData[featureId][i].instanceId = instanceId; // Update the instanceId for each node in this array to match the new instanceId key
                }
                delete nodeListData[nodeListDataKeyForThisFeature];
            } else {
                console.log(`No existing node list data found for feature with key "${featureKey}". Creating new node list data for feature ID "${featureId}"...`);
                // Create a new array for this featureId based on the workspace config for this feature
                // nodeListData[featureId] = null; // []; // JSON.parse(JSON.stringify(featureConfigs[0].nodes)); // Deep copy the nodes from the workspace config
            }
        }
    }

    console.log('Finished fixing node list data for loaded node list data. Updated node list data:', nodeListData);
}